import {
  ON_START_GET_LOBBY_CUSTOM, ON_GET_LOBBY_CUSTOM, ON_ERROR_GET_LOBBY_CUSTOM,

  ON_GET_UPDATE_DASHBOARD_BOKATV,ON_GET_UPDATE_DASHBOARD,ON_GET_UPDATE_DASHBOARD_ORDERTV,
  ON_GET_UPDATE_DASHBOARD_DIALER,ON_GET_UPDATE_DASHBOARD_AKTIVITET,ON_GET_UPDATE_DASHBOARD_PROSPEKT,
  ON_GET_UPDATE_DASHBOARD_OFFERT,ON_GET_UPDATE_DASHBOARD_PROJEKT,ON_GET_UPDATE_DASHBOARD_TIDPROJEKT,
  ON_GET_UPDATE_DASHBOARD_ARENDE,ON_GET_UPDATE_DASHBOARD_AVTAL,ON_GET_UPDATE_DASHBOARD_LYNES,
  ON_GET_UPDATE_DASHBOARD_DEVICE,ON_GET_UPDATE_DASHBOARD_ISMESSAGE,


  
    ON_START_FETCH_VUNNEN_MONTH,
    ON_FETCH_VUNNEN_MONTH,
    ON_ERROR_FETCH_VUNNEN_MONTH,
    ON_START_FETCH_AVSLUTA_AFFAR,
    ON_FETCH_AVSLUTA_AFFAR,
    ON_ERROR_FETCH_AVSLUTA_AFFAR,
    ON_START_FETCH_DASHORDER_LIST,
    ON_FETCH_DASHORDER_LIST,
    ON_ERROR_FETCH_DASHORDER_LIST,
    ON_START_FETCH_MOTE_MONTH,
    ON_FETCH_MOTE_MONTH,
    ON_ERROR_FETCH_MOTE_MONTH,
    ON_START_FETCH_ORDER_VUNNEN_MONTH,  ON_FETCH_ORDER_VUNNEN_MONTH, ON_ERROR_FETCH_ORDER_VUNNEN_MONTH,
    ON_START_FETCH_NYKUND_MOTE, ON_FETCH_NYKUND_MOTE, ON_ERROR_FETCH_NYKUND_MOTE,
    ON_START_FETCH_NYUPPKUND_MOTE, ON_FETCH_NYUPPKUND_MOTE, ON_ERROR_FETCH_NYUPPKUND_MOTE,
    ON_START_FETCH_BEFKUND_MOTE, ON_FETCH_BEFKUND_MOTE, ON_ERROR_FETCH_BEFKUND_MOTE,
    ON_START_FETCH_AVBOKA_MOTE, ON_FETCH_AVBOKA_MOTE, ON_ERROR_FETCH_AVBOKA_MOTE,
    ON_START_FETCH_GENOM_MOTE, ON_FETCH_GENOM_MOTE, ON_ERROR_FETCH_GENOM_MOTE,
    ON_START_FETCH_SUMMA_OFFERT_MONTH, ON_FETCH_SUMMA_OFFERT_MONTH, ON_ERROR_FETCH_SUMMA_OFFERT_MONTH,
    ON_START_FETCH_SKAPAD_PROSPEKT_MONTH, ON_FETCH_SKAPAD_PROSPEKT_MONTH, ON_ERROR_FETCH_SKAPAD_PROSPEKT_MONTH,
    ON_START_FETCH_AKTIVA_AVTAL,ON_FETCH_AKTIVA_AVTAL,ON_ERROR_FETCH_AKTIVA_AVTAL,
    ON_START_FETCH_AVTAL_TABLE_ABONN,ON_FETCH_AVTAL_TABLE_ABONN,ON_ERROR_FETCH_AVTAL_TABLE_ABONN,
    ON_START_FETCH_AVTALINVOICING_TABLE_ABONN, ON_FETCH_AVTALINVOICING_TABLE_ABONN, ON_ERROR_FETCH_AVTALINVOICING_TABLE_ABONN,
    ON_START_FETCH_AVTAL_TABLE_ENGÅNG,ON_FETCH_AVTAL_TABLE_ENGÅNG,ON_ERROR_FETCH_AVTAL_TABLE_ENGÅNG,
    ON_START_FETCH_AVTAL_TABLE_ALL,ON_FETCH_AVTAL_TABLE_ALL,ON_ERROR_FETCH_AVTAL_TABLE_ALL,
    ON_START_FETCH_AVTAL_GRAPH_VALUE_REMAINING,ON_FETCH_AVTAL_GRAPH_VALUE_REMAINING,ON_ERROR_FETCH_AVTAL_GRAPH_VALUE_REMAINING,
    ON_START_FETCH_AVTAL_SUM_VALUE_REMAINING,ON_FETCH_AVTAL_SUM_VALUE_REMAINING,ON_ERROR_FETCH_AVTAL_SUM_VALUE_REMAINING,
    ON_START_FETCH_KLARA_AKTIVITET_MONTH, ON_FETCH_KLARA_AKTIVITET_MONTH, ON_ERROR_FETCH_KLARA_AKTIVITET_MONTH,
    ON_START_FETCH_ABO_VUNNEN_MONTH,ON_FETCH_ABO_VUNNEN_MONTH,ON_ERROR_FETCH_ABO_VUNNEN_MONTH,
    ON_START_FETCH_ABON_VUNNEN_MONTH, ON_FETCH_ABON_VUNNEN_MONTH,ON_ERROR_FETCH_ABON_VUNNEN_MONTH,
    ON_START_FETCH_VUNNEN_CHART,ON_FETCH_VUNNEN_CHART,ON_ERROR_FETCH_VUNNEN_CHART,
    ON_START_FETCH_VUNNEN_MONTH_CHART,ON_FETCH_VUNNEN_MONTH_CHART,ON_ERROR_FETCH_VUNNEN_MONTH_CHART,
    ON_FETCH_SUMMA_BILLING_AVTAL, ON_ERROR_FETCH_SUMMA_BILLING_AVTAL, ON_START_FETCH_SUMMA_BILLING_AVTAL,
    ON_FETCH_SUMMA_ABONNEMANG_AVTAL, ON_ERROR_FETCH_SUMMA_ABONNEMANG_AVTAL, ON_START_FETCH_SUMMA_ABONNEMANG_AVTAL,
    ON_START_FETCH_AKTIVITITER_CHART,ON_FETCH_AKTIVITITER_CHART,ON_ERROR_FETCH_AKTIVITITER_CHART,
    ON_START_FETCH_DASHBOARD_FILTER,ON_FETCH_DASHBOARD_FILTER,ON_ERROR_FETCH_DASHBOARD_FILTER,
    ON_START_FETCH_BESTLIST_DIALER_BYAFID,ON_FETCH_BESTLIST_DIALER_BYAFID,ON_ERROR_BESTLIST_DIALER_BYAFID,
    ON_START_FETCH_AKTIVAKUNDER_DIALER_BYAFID,ON_FETCH_AKTIVAKUNDER_DIALER_BYAFID,ON_ERROR_AKTIVAKUNDER_DIALER_BYAFID,
    ON_START_FETCH_BOKAMOTE_DIALER_BYAFID,ON_FETCH_BOKAMOTE_DIALER_BYAFID,ON_ERROR_BOKAMOTE_DIALER_BYAFID,
    ON_START_FETCH_SALTABLE_DIALER_BYAFID,ON_FETCH_SALTABLE_DIALER_BYAFID,ON_ERROR_SALTABLE_DIALER_BYAFID,
    ON_START_FETCH_LYNES_SAMTAL_BYAFID,ON_FETCH_LYNES_SAMTAL_BYAFID,ON_ERROR_LYNES_SAMTAL_BYAFID,
    ON_START_FETCH_LYNES_SAMTAL_ANTAL_BYAFID,ON_FETCH_LYNES_SAMTAL_ANTAL_BYAFID,ON_ERROR_LYNES_SAMTAL_ANTAL_BYAFID,
    ON_START_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID,ON_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID,ON_ERROR_LYNES_SAMTAL_AVG_DUR_BYAFID,
    ON_START_FETCH_LYNES_SAMTAL_TABLE_BYAFID, ON_FETCH_LYNES_SAMTAL_TABLE_BYAFID, ON_ERROR_LYNES_SAMTAL_TABLE_BYAFID,
    ON_START_FETCH_LYNES_SAMTAL_GRAPH_BYAFID, ON_FETCH_LYNES_SAMTAL_GRAPH_BYAFID, ON_ERROR_LYNES_SAMTAL_GRAPH_BYAFID,
    ON_START_FETCH_AVSLUT_DIALER_BYAFID,ON_FETCH_AVSLUT_DIALER_BYAFID,ON_ERROR_AVSLUT_DIALER_BYAFID,
    ON_START_FETCH_STATUS_DIALER_BYAFID,ON_FETCH_STATUS_DIALER_BYAFID,ON_ERROR_STATUS_DIALER_BYAFID,
    ON_START_FETCH_AKTIVITED_DIALER_BYAFID,ON_FETCH_AKTIVITED_DIALER_BYAFID,ON_ERROR_AKTIVITED_DIALER_BYAFID,
    ON_START_FETCH_TOPLIST_SAL_BYAFID,ON_FETCH_TOPLIST_SAL_BYAFID,ON_ERROR_TOPLIST_SAL_BYAFID,
    ON_START_FETCH_TOPLIST_SALANTAL_BYAFID,ON_FETCH_TOPLIST_SALANTAL_BYAFID,ON_ERROR_TOPLIST_SALANTAL_BYAFID,
    ON_START_FETCH_AFFAR_SALANTAL_BYAFID,ON_FETCH_AFFAR_SALANTAL_BYAFID,ON_ERROR_AFFAR_SALANTAL_BYAFID,
    ON_START_FETCH_AFFAR_SAL_BYAFID,ON_FETCH_AFFAR_SAL_BYAFID,ON_ERROR_AFFAR_SAL_BYAFID,
    ON_START_FETCH_AVTAL_VALUE_SAL_BYAFID,ON_FETCH_AVTAL_VALUE_SAL_BYAFID,ON_ERROR_AVTAL_VALUE_SAL_BYAFID,
    ON_START_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID ,ON_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID, ON_ERROR_AVTAL_VALUE_BILLING_SAL_BYAFID,
    ON_START_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,ON_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,ON_ERROR_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,
    ON_START_FETCH_AFFAR_PROBABILITY_SAL_BYAFID,ON_FETCH_AFFAR_PROBABILITY_SAL_BYAFID,ON_ERROR_AFFAR_PROBABILITY_SAL_BYAFID,
    ON_START_FETCH_TOPLIST_BOK_BYAFID,ON_FETCH_TOPLIST_BOK_BYAFID,ON_ERROR_TOPLIST_BOK_BYAFID,
    ON_START_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID,ON_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID,ON_ERROR_TOPLIST_ANTAL_TAGGAR_BYAFID,
    ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID,ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID,ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID,
    ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B,ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B,ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_B,
    ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G,ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G,ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_G,
    ON_START_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID, ON_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID, ON_ERROR_BOKAMOTE_ANTAL_BOKAV_BYAFID,
    ON_START_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID, ON_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID, ON_ERROR_BOKAMOTE_ANTAL_BOKTILL_BYAFID,
    ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID, ON_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID, ON_ERROR_AVBOKAMOTE_ANTAL_BOKAV_BYAFID,
    ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID, ON_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID, ON_ERROR_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID,


    ON_START_FETCH_ANTAL_BOK_BYAFID,ON_FETCH_ANTAL_BOK_BYAFID,ON_ERROR_ANTAL_BOK_BYAFID,
    ON_START_FETCH_TABEL_BOK_BYAFID,ON_FETCH_TABEL_BOK_BYAFID,ON_ERROR_TABEL_BOK_BYAFID,
    ON_START_FETCH_UTFALL_BOK_BYAFID,ON_FETCH_UTFALL_BOK_BYAFID,ON_ERROR_UTFALL_BOK_BYAFID,
    ON_START_FETCH_MONTH_PROSPEKTD_BYAFID,ON_FETCH_MONTH_PROSPEKTD_BYAFID,ON_ERROR_MONTH_PROSPEKTD_BYAFID,
    ON_START_FETCH_KVARTAL_PROSPEKTD_BYAFID,ON_FETCH_KVARTAL_PROSPEKTD_BYAFID,ON_ERROR_KVARTAL_PROSPEKTD_BYAFID,
    ON_START_FETCH_VUNNENLIST_PROSPEKTD_BYAFID,ON_FETCH_VUNNENLIST_PROSPEKTD_BYAFID,ON_ERROR_VUNNENLIST_PROSPEKTD_BYAFID,
    ON_START_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID,ON_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID,ON_ERROR_VUNNENLISTK_PROSPEKTD_BYAFID,
    ON_START_FETCH_PIPELINE_PROSPEKTD_BYAFID,ON_FETCH_PIPELINE_PROSPEKTD_BYAFID,ON_ERROR_PIPELINE_PROSPEKTD_BYAFID,
    ON_START_FETCH_UTFALL_PROSPEKTD_BYAFID,ON_FETCH_UTFALL_PROSPEKTD_BYAFID,ON_ERROR_UTFALL_PROSPEKTD_BYAFID,
    ON_START_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID,ON_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID,ON_ERROR_UTFALL_PROBABILITY_PROSPEKT_BYAFID,
    ON_START_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID,ON_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID,ON_ERROR_TOPLIST_PROBABILITY_VALUE_BYAFID,
    ON_START_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID,ON_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID,ON_ERROR_UTFALL_ANTAL_PROSPEKT_BYAFID,
    ON_START_FETCH_UTFALLS_PROSPEKTD_BYAFID,ON_FETCH_UTFALLS_PROSPEKTD_BYAFID,ON_ERROR_UTFALLS_PROSPEKTD_BYAFID,
    ON_START_FETCH_TOPLIST_KONTOR_BYAFID, ON_FETCH_TOPLIST_KONTOR_BYAFID, ON_ERROR_TOPLIST_KONTOR_BYAFID,
    ON_START_FETCH_LIST_KONTOR_BYAFID, ON_FETCH_LIST_KONTOR_BYAFID, ON_ERROR_LIST_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLS_KONTOR_BYAFID, ON_FETCH_UTFALLS_KONTOR_BYAFID, ON_ERROR_UTFALLS_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLSPRO_KONTOR_BYAFID, ON_FETCH_UTFALLSPRO_KONTOR_BYAFID, ON_ERROR_UTFALLSPRO_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLSORD_KONTOR_BYAFID, ON_FETCH_UTFALLSORD_KONTOR_BYAFID, ON_ERROR_UTFALLSORD_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLSKAKT_KONTOR_BYAFID, ON_FETCH_UTFALLSKAKT_KONTOR_BYAFID, ON_ERROR_UTFALLSKAKT_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLSNOFF_KONTOR_BYAFID, ON_FETCH_UTFALLSNOFF_KONTOR_BYAFID, ON_ERROR_UTFALLSNOFF_KONTOR_BYAFID,
    ON_START_FETCH_UTFALLSBMOTE_KONTOR_BYAFID, ON_FETCH_UTFALLSBMOTE_KONTOR_BYAFID, ON_ERROR_UTFALLSBMOTE_KONTOR_BYAFID,
    ON_START_FETCH_LASTVUNNEN_KONTOR_BYAFID, ON_FETCH_LASTVUNNEN_KONTOR_BYAFID, ON_ERROR_LASTVUNNEN_KONTOR_BYAFID,
    ON_START_FETCH_BOKADE_KONTOR_BYAFID, ON_FETCH_BOKADE_KONTOR_BYAFID, ON_ERROR_BOKADE_KONTOR_BYAFID,
    ON_START_FETCH_COUNT_OFFERT_MONTH, ON_FETCH_COUNT_OFFERT_MONTH, ON_ERROR_FETCH_COUNT_OFFERT_MONTH,

    ON_START_FETCH_COUNT_ARENDE_NY_MONTH, ON_FETCH_COUNT_ARENDE_NY_MONTH, ON_ERROR_FETCH_COUNT_ARENDE_NY_MONTH,
    ON_START_FETCH_COUNT_ARENDE_KLARA_MONTH, ON_FETCH_COUNT_ARENDE_KLARA_MONTH, ON_ERROR_FETCH_COUNT_ARENDE_KLARA_MONTH,
    ON_START_FETCH_COUNT_ARENDE_OPPNA_MONTH, ON_FETCH_COUNT_ARENDE_OPPNA_MONTH, ON_ERROR_FETCH_COUNT_ARENDE_OPPNA_MONTH,
    ON_START_FETCH_COUNT_ARENDE_NYA_TOP_LIST,ON_FETCH_COUNT_ARENDE_NYA_TOP_LIST,ON_ERROR_FETCH_COUNT_ARENDE_NYA_TOP_LIST,
    ON_START_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER,ON_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER,ON_ERROR_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER,
    ON_START_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR, ON_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR, ON_ERROR_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR,
    ON_START_FETCH_COUNT_LAST_ARENDE, ON_FETCH_COUNT_LAST_ARENDE, ON_ERROR_FETCH_COUNT_LAST_ARENDE,
    
    ON_START_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR,ON_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR,ON_ERROR_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR,
    ON_START_FETCH_AVTAL_VALUE_YEAR_BYAFID,ON_FETCH_AVTAL_VALUE_YEAR_BYAFID,ON_ERROR_AVTAL_VALUE_YEAR_BYAFID,

		ON_FETCH_TOTAL_SALES, ON_ERROR_FETCH_TOTAL_SALES,ON_START_FETCH_TOTAL_SALES,
		ON_FETCH_MRR, ON_ERROR_FETCH_MRR,ON_START_FETCH_MRR,
		ON_FETCH_ARR, ON_ERROR_FETCH_ARR, ON_START_FETCH_ARR,
		ON_FETCH_ARPU, ON_ERROR_FETCH_ARPU, ON_START_FETCH_ARPU,

    ON_START_FETCH_PROJECT_WORKLOAD,ON_FETCH_PROJECT_WORKLOAD,ON_ERROR_FETCH_PROJECT_WORKLOAD,
    ON_START_FETCH_PROJECT_CREATEDVSCOMPLETED, ON_FETCH_PROJECT_CREATEDVSCOMPLETED, ON_ERROR_FETCH_PROJECT_CREATEDVSCOMPLETED,
    ON_START_FETCH_PROJECT_TASKS, ON_FETCH_PROJECT_TASKS, ON_ERROR_FETCH_PROJECT_TASKS,
    ON_ERROR_FETCH_DASHBOARD_SALJ_FILTER, ON_FETCH_DASHBOARD_SALJ_FILTER, ON_START_FETCH_DASHBOARD_SALJ_FILTER,
    ON_START_FETCH_PROJECT_TIMESPENT, ON_FETCH_PROJECT_TIMESPENT, ON_ERROR_FETCH_PROJECT_TIMESPENT,
    ON_START_FETCH_PROJECT_STATUS_LIST_ANTAL, ON_FETCH_PROJECT_STATUS_LIST_ANTAL, ON_ERROR_FETCH_PROJECT_STATUS_LIST_ANTAL,
    ON_START_FETCH_PROJECT_KLARA_KORT_TM,ON_FETCH_PROJECT_KLARA_KORT_TM,ON_ERROR_FETCH_PROJECT_KLARA_KORT_TM,
    ON_START_FETCH_PROJECT_KORT_KVAR_TM,ON_FETCH_PROJECT_KORT_KVAR_TM,ON_ERROR_FETCH_PROJECT_KORT_KVAR_TM,
    ON_START_FETCH_DASHBOARD_BOKA_FILTER,ON_FETCH_DASHBOARD_BOKA_FILTER,ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER,
    ON_FETCH_DASHBOARD_ORDER_FILTER,ON_FETCH_DASHBOARD_BARN_FILTER,
    ON_START_FETCH_DASHBOARD_DIALER_FILTER, ON_FETCH_DASHBOARD_DIALER_FILTER, ON_ERROR_FETCH_DASHBOARD_DIALER_FILTER,
    ON_START_FETCH_UTFALL_BOK_BUDGET_BYAFID,ON_FETCH_UTFALL_BOK_BUDGET_BYAFID,ON_ERROR_UTFALL_BOK_BUDGET_BYAFID,
    ON_START_FETCH_ORDERTYPE_ANTAL_BYAFID, ON_FETCH_ORDERTYPE_ANTAL_BYAFID, ON_ERROR_ORDERTYPE_ANTAL_BYAFID,
    ON_START_FETCH_PROSPEKTTYPE_ANTAL_BYAFID,ON_FETCH_PROSPEKTTYPE_ANTAL_BYAFID,ON_ERROR_PROSPEKTTYPE_ANTAL_BYAFID,
    ON_START_FETCH_AVTAL_TYPE_ANTAL_BYAFID ,ON_FETCH_AVTAL_TYPE_ANTAL_BYAFID, ON_ERROR_AVTAL_TYPE_ANTAL_BYAFID,
    ON_START_FETCH_AVTAL_GROWTH_BYAFID, ON_FETCH_AVTAL_GROWTH_BYAFID, ON_ERROR_AVTAL_GROWTH_BYAFID,
    ON_START_FETCH_ARTIKLAR_ANTAL_BYAFID, ON_FETCH_ARTIKLAR_ANTAL_BYAFID, ON_ERROR_ARTIKLAR_ANTAL_BYAFID,
    ON_START_FETCH_NY_ORDER_ANTAL_BYAFID, ON_FETCH_NY_ORDER_ANTAL_BYAFID, ON_ERROR_NY_ORDER_ANTAL_BYAFID,
    ON_START_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID, ON_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID, ON_ERROR_NY_ORDER_ARTIKLAR_ANTAL_BYAFID,
    ON_START_FETCH_STATUS_ORDER_ANTAL_BYAFID, ON_FETCH_STATUS_ORDER_ANTAL_BYAFID, ON_ERROR_STATUS_ORDER_ANTAL_BYAFID,
    ON_START_FETCH_STATUS_HAS_ABONN, ON_FETCH_STATUS_HAS_ABONN, ON_ERROR_STATUS_HAS_ABONN,
    ON_START_FETCH_STATUS_HAS_ORERV,ON_FETCH_STATUS_HAS_ORERV,ON_ERROR_STATUS_HAS_ORERV, 
    ON_START_FETCH_ORDER_VARDE_YEAR, ON_FETCH_ORDER_VARDE_YEAR, ON_ERROR_ORDER_VARDE_YEAR,
    ON_START_FETCH_TOPLIST_CHILD_KONTO_BYAFID, ON_FETCH_TOPLIST_CHILD_KONTO_BYAFID, ON_ERROR_TOPLIST_CHILD_KONTO_BYAFID,
    ON_START_FETCH_LIST_CHILD_KONTO_BYAFID, ON_FETCH_LIST_CHILD_KONTO_BYAFID, ON_ERROR_LIST_CHILD_KONTO_BYAFID,
    ON_START_FETCH_UTFALLS_CHILD_KONTO_BYAFID, ON_FETCH_UTFALLS_CHILD_KONTO_BYAFID, ON_ERROR_UTFALLS_CHILD_KONTO_BYAFID,
    ON_START_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID, ON_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID, ON_ERROR_UTFALLSORD_CHILD_KONTO_BYAFID,
    ON_START_FETCH_ORDRAR_CHILD_KONTO_BYAFID, ON_FETCH_ORDRAR_CHILD_KONTO_BYAFID, ON_ERROR_ORDRAR_CHILD_KONTO_BYAFID,
    ON_START_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID, ON_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID, ON_ERROR_UTFALLSBMOTE_CHILD_KONTO_BYAFID,
    ON_START_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID, ON_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID, ON_ERROR_LASTVUNNEN_CHILD_KONTO_BYAFID,
    ON_START_FETCH_BOKADE_CHILD_KONTO_BYAFID, ON_FETCH_BOKADE_CHILD_KONTO_BYAFID, ON_ERROR_BOKADE_CHILD_KONTO_BYAFID, 
    ON_START_FETCH_PROJECT_AHEAD_BEHIND, ON_FETCH_PROJECT_AHEAD_BEHIND, ON_ERROR_FETCH_PROJECT_AHEAD_BEHIND,
    ON_START_FETCH_PROJECT_DEADLINE_LIST_ANTAL,ON_START_FETCH_DASHBOARD_ORDER_FILTER,
    ON_START_FETCH_DASHBOARD_PROSPEKT_FILTER, ON_FETCH_DASHBOARD_PROSPEKT_FILTER, ON_ERROR_FETCH_DASHBOARD_PROSPEKT_FILTER,
    ON_START_FETCH_DASHBOARD_KONTOR_FILTER,ON_FETCH_DASHBOARD_KONTOR_FILTER,ON_ERROR_FETCH_DASHBOARD_KONTOR_FILTER,
    ON_FETCH_PROJECT_DEADLINE_LIST_ANTAL,
    ON_ERROR_FETCH_PROJECT_DEADLINE_LIST_ANTAL,
    ON_START_GET_DASHBOARD_CUSTOM_LIST,
    ON_GET_DASHBOARD_CUSTOM_LIST,
    ON_ERROR_GET_DASHBOARD_CUSTOM_LIST,
    ON_START_ADD_DASHBOARD_CUSTOM,
    ON_ADD_DASHBOARD_CUSTOM,
    ON_ERROR_ADD_DASHBOARD_CUSTOM,
    ON_START_REMOVE_DASHBOARD_CUSTOM,
    ON_REMOVE_DASHBOARD_CUSTOM,
    ON_ERROR_REMOVE_DASHBOARD_CUSTOM,
    ON_START_GET_DASHBOARD_CUSTOM,
    ON_GET_DASHBOARD_CUSTOM,
    ON_ERROR_GET_DASHBOARD_CUSTOM,
    ON_START_UPDATE_DASHBOARD_CUSTOM,
    ON_UPDATE_DASHBOARD_CUSTOM,
    ON_ERROR_UPDATE_DASHBOARD_CUSTOM,
    ON_START_DELETE_DASHBOARD_CUSTOM,
    ON_DELETE_DASHBOARD_CUSTOM,
    ON_ERROR_DELETE_DASHBOARD_CUSTOM,

    ON_START_GET_DASHBOARD_COMPETITION_LIST,
    ON_GET_DASHBOARD_COMPETITION_LIST,
    ON_ERROR_GET_DASHBOARD_COMPETITION_LIST,
    ON_START_ADD_DASHBOARD_COMPETITION,
    ON_ADD_DASHBOARD_COMPETITION,
    ON_ERROR_ADD_DASHBOARD_COMPETITION,
    ON_START_REMOVE_DASHBOARD_COMPETITION,
    ON_REMOVE_DASHBOARD_COMPETITION,
    ON_ERROR_REMOVE_DASHBOARD_COMPETITION,
    ON_START_GET_DASHBOARD_COMPETITION,
    ON_GET_DASHBOARD_COMPETITION,
    ON_ERROR_GET_DASHBOARD_COMPETITION,
    ON_START_UPDATE_DASHBOARD_COMPETITION,
    ON_UPDATE_DASHBOARD_COMPETITION,
    ON_ERROR_UPDATE_DASHBOARD_COMPETITION,
    ON_START_DELETE_DASHBOARD_COMPETITION,
    ON_DELETE_DASHBOARD_COMPETITION,
    ON_ERROR_DELETE_DASHBOARD_COMPETITION,
    ON_POST_CHAT_DASHBOARD_COMPETITION,
    ON_START_POST_CHAT_DASHBOARD_COMPETITION,
    ON_ERROR_POST_CHAT_DASHBOARD_COMPETITION,
    
    ON_START_GET_DASHBOARD_TV_DEVICE_LIST,
    ON_GET_DASHBOARD_TV_DEVICE_LIST,
    ON_ERROR_GET_DASHBOARD_TV_DEVICE_LIST,
    ON_START_ADD_DASHBOARD_TV_DEVICE,
    ON_ADD_DASHBOARD_TV_DEVICE,
    ON_ERROR_ADD_DASHBOARD_TV_DEVICE ,
    ON_START_REMOVE_DASHBOARD_TV_DEVICE,
    ON_REMOVE_DASHBOARD_TV_DEVICE,
    ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE,
    ON_START_CONNECT_DASHBOARD_TV_DEVICE,
    ON_CONNECT_DASHBOARD_TV_DEVICE,
    ON_ERROR_CONNECT_DASHBOARD_TV_DEVICE,
    
    ON_START_INIT_DASHBOARD_TV_DEVICE,
    ON_INIT_DASHBOARD_TV_DEVICE,
    ON_ERROR_INIT_DASHBOARD_TV_DEVICE,

    ON_START_ADD_DASHBOARD_TV_DEVICE_VY,
    ON_ADD_DASHBOARD_TV_DEVICE_VY,
    ON_ERROR_ADD_DASHBOARD_TV_DEVICE_VY,
    ON_START_REMOVE_DASHBOARD_TV_DEVICE_VY,
    ON_REMOVE_DASHBOARD_TV_DEVICE_VY,
    ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE_VY,
    ON_START_UPDATE_DASHBOARD_TV_DEVICE_VY,
    ON_UPDATE_DASHBOARD_TV_DEVICE_VY,
    ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY,
} from "../constants/ActionTypes";
import axios from 'util/ApiDashboard' 
import { isEmpty,isUndefined,isNull } from "lodash";
import {userSignOut} from 'actions'
import {history} from 'store'
import { v4 as uuidv4 } from 'uuid';
import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Hex.parse('1234567890abcdef1234567890abcdef1234567890abcdef1234567890abcdef');
const iv = CryptoJS.enc.Hex.parse('abcdef9876543210abcdef9876543210');

export function encrypt(data) {
  const encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv });
  return { 
      iv: iv.toString(),  // Sending the IV as a hex string
      encryptedData: encrypted.toString()  // Base64 encoded
  };
}

// Decryption function
export function decrypt(encryptedData, iv) {
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key, { iv: CryptoJS.enc.Hex.parse(iv) });
  return decrypted.toString(CryptoJS.enc.Utf8);
}



//DashboardTV enheter
export const updateDashboardTVDeviceMeta = ( Afid, Userid, Meta, Value, Deviceid) => {
  return (dispatch) => {
    dispatch({type: ON_START_UPDATE_DASHBOARD_TV_DEVICE_VY})
    axios.put('kontos/DashBoard/device',
    { body:encrypt(JSON.stringify({Userid, Afid, Meta, Value, Deviceid})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateDashboardTVDeviceVy: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_DASHBOARD_TV_DEVICE_VY, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateDashboardTVDeviceVy: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
export const updateDashboardTVDeviceVy = ( Afid, Userid, Vy) => {
  return (dispatch) => {
    dispatch({type: ON_START_UPDATE_DASHBOARD_TV_DEVICE_VY})
    axios.put('kontos/DashBoard/device/vy',
    { body:encrypt(JSON.stringify({Userid, Afid, Vy})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateDashboardTVDeviceVy: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_DASHBOARD_TV_DEVICE_VY, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateDashboardTVDeviceVy: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
//DashboardTV enheter
export const updateDashboardTVDeviceVyKontor = ( Afid, Userid, Vy,OfficeID) => {
  return (dispatch) => {
    dispatch({type: ON_START_UPDATE_DASHBOARD_TV_DEVICE_VY})
    axios.put('kontos/DashBoard/Office/device/vy',
    { body:encrypt(JSON.stringify({Userid, Afid, Vy,OfficeID})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateDashboardTVDeviceVy1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_DASHBOARD_TV_DEVICE_VY, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateDashboardTVDeviceVy2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_DASHBOARD_TV_DEVICE_VY, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
export const removeDashboardTVDeviceVy = ( Afid, Userid, Vyid) => {
  return (dispatch) => {
    dispatch({type: ON_START_REMOVE_DASHBOARD_TV_DEVICE_VY})
    axios.delete('kontos/DashBoard/device/vy',
    { params:encrypt(JSON.stringify({Userid, Afid, Vyid})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeDashboardTVDeviceVy1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_REMOVE_DASHBOARD_TV_DEVICE_VY, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("removeDashboardTVDeviceVy2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE_VY, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE_VY, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
export const removeDashboardTVDeviceVyKontor = ( Afid, Userid, Vyid,OfficeID) => {
  return (dispatch) => {
    dispatch({type: ON_START_REMOVE_DASHBOARD_TV_DEVICE_VY})
    axios.delete('kontos/DashBoard/Office/device/vy',
    { params:encrypt(JSON.stringify({Userid, Afid, Vyid,OfficeID})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeDashboardTVDeviceVy1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_REMOVE_DASHBOARD_TV_DEVICE_VY, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("removeDashboardTVDeviceVy2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE_VY, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE_VY, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
export const addDashboardTVDeviceVy = ( Afid, Userid, Deviceid) => {
  return (dispatch) => {
    dispatch({type: ON_START_ADD_DASHBOARD_TV_DEVICE_VY})
    axios.post('kontos/DashBoard/device/vy',
    { body:encrypt(JSON.stringify({Userid, Afid, Deviceid})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addDashboardTVDeviceVy1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ADD_DASHBOARD_TV_DEVICE_VY, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addDashboardTVDeviceVy2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ADD_DASHBOARD_TV_DEVICE_VY, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_ADD_DASHBOARD_TV_DEVICE_VY, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
export const addDashboardTVDeviceVyKontor = ( Afid, Userid, Deviceid,OfficeID) => {
  return (dispatch) => {
    dispatch({type: ON_START_ADD_DASHBOARD_TV_DEVICE_VY})
    axios.post('kontos/DashBoard/Office/device/vy',
    { body:encrypt(JSON.stringify({Userid, Afid, Deviceid,OfficeID})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addDashboardTVDeviceVy1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ADD_DASHBOARD_TV_DEVICE_VY, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addDashboardTVDeviceVy2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ADD_DASHBOARD_TV_DEVICE_VY, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_ADD_DASHBOARD_TV_DEVICE_VY, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}

  export const initiateDevice = () => {
    let access_token = localStorage.getItem('notyfile_device_access_token')
    if(isNull(access_token)) {
      access_token = uuidv4()
      localStorage.setItem('notyfile_device_access_token',access_token)
    }

    return (dispatch) => {
      dispatch({type: ON_START_INIT_DASHBOARD_TV_DEVICE})
      axios.get('kontos/DashBoard/device/init',
      { params:encrypt(JSON.stringify({access_token:access_token})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("connectThisDashboardTVDevice1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_INIT_DASHBOARD_TV_DEVICE, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("connectThisDashboardTVDevice2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_INIT_DASHBOARD_TV_DEVICE, payload: ndate.error});
        }
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_INIT_DASHBOARD_TV_DEVICE, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
        }
        
      });
    }
  }
  export const connectThisDashboardTVDevice = (code) => {
    return (dispatch) => {
      dispatch({type: ON_START_CONNECT_DASHBOARD_TV_DEVICE})
      axios.put('kontos/DashBoard/device/connect',
      { body:encrypt(JSON.stringify({code})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("connectThisDashboardTVDevice1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_CONNECT_DASHBOARD_TV_DEVICE, payload: ndate.results});
          localStorage.setItem('noty_device_access_token', ndate.results.access_token)
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("connectThisDashboardTVDevice2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_CONNECT_DASHBOARD_TV_DEVICE, payload: ndate.error});
        }
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_CONNECT_DASHBOARD_TV_DEVICE, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
        }
        
      });
    }
  }
  //getDashboardTVDevicesKontor
  export const getDashboardTVDevicesKontor = (Afid, Userid,OfficeID) => {
    return (dispatch) => {
      dispatch({type: ON_START_GET_DASHBOARD_TV_DEVICE_LIST})
      axios.get('kontos/DashBoard/Office/device',
      { params:encrypt(JSON.stringify({Userid, Afid,OfficeID})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getDashboardTVDevices1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_DASHBOARD_TV_DEVICE_LIST, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getDashboardTVDevices2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_DASHBOARD_TV_DEVICE_LIST, payload: ndate.error});
        }
       
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_GET_DASHBOARD_TV_DEVICE_LIST, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
        }
        
      });
    }
  }
  //
  export const getDashboardTVDevices = (Afid, Userid) => {
    return (dispatch) => {
      dispatch({type: ON_START_GET_DASHBOARD_TV_DEVICE_LIST})
      axios.get('kontos/DashBoard/device',
      { params:encrypt(JSON.stringify({Userid, Afid})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getDashboardTVDevices1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_DASHBOARD_TV_DEVICE_LIST, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getDashboardTVDevices2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_DASHBOARD_TV_DEVICE_LIST, payload: ndate.error});
        }
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_GET_DASHBOARD_TV_DEVICE_LIST, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
        }
        
      });
    }
  }
//addDashboardTVDeviceKontor
export const addDashboardTVDeviceKontor = ( Afid, Userid,OfficeID, Name, code) => {
  return (dispatch) => {
    dispatch({type: ON_START_ADD_DASHBOARD_TV_DEVICE})
    axios.post('kontos/DashBoard/Office/device',
    { body:encrypt(JSON.stringify({Userid, Afid, Name, code,OfficeID})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addDashboardTVDevice1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ADD_DASHBOARD_TV_DEVICE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addDashboardTVDevice2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ADD_DASHBOARD_TV_DEVICE, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_ADD_DASHBOARD_TV_DEVICE, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
//
export const addDashboardTVDevice = ( Afid, Userid, Name, code) => {
  return (dispatch) => {
    dispatch({type: ON_START_ADD_DASHBOARD_TV_DEVICE})
    axios.post('kontos/DashBoard/device',
    { body:encrypt(JSON.stringify({Userid, Afid, Name, code})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("addDashboardTVDevice1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ADD_DASHBOARD_TV_DEVICE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("addDashboardTVDevice2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ADD_DASHBOARD_TV_DEVICE, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_ADD_DASHBOARD_TV_DEVICE, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
export const removeDashboardTVDevice = (Userid, Afid, Deviceid) => {
  return (dispatch) => {
    dispatch({type: ON_START_REMOVE_DASHBOARD_TV_DEVICE})
    axios.delete('kontos/DashBoard/device',
    { params:encrypt(JSON.stringify({Userid, Afid, Deviceid})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeDashboardTVDevice1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_REMOVE_DASHBOARD_TV_DEVICE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("removeDashboardTVDevice2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
export const removeDashboardTVDeviceKontor = (Userid, Afid, Deviceid,OfficeID) => {
  return (dispatch) => {
    dispatch({type: ON_START_REMOVE_DASHBOARD_TV_DEVICE})
    axios.delete('kontos/DashBoard/Office/device',
    { params:encrypt(JSON.stringify({Userid, Afid, Deviceid,OfficeID})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("removeDashboardTVDevice1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_REMOVE_DASHBOARD_TV_DEVICE, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("removeDashboardTVDevice2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE, payload: ndate.error});
      }
     })
     .catch(function (error) {
       dispatch({type: ON_ERROR_REMOVE_DASHBOARD_TV_DEVICE, payload: error.message});
       console.log("Error****:", error.message);
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       
     });
  }
}
//CustomDashboard
export const addCustomDashboard = (Userid,Afid, Name, Medarbetare) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_ADD_DASHBOARD_CUSTOM});
     axios.post('kontos/DashBoard/custom',
     { body:encrypt(JSON.stringify({Userid:Userid,Afid:Afid,Name:Name, Medarbetare:Medarbetare})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("addCustomDashboard1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ADD_DASHBOARD_CUSTOM, payload: ndate.results});
          history.push({pathname:"/app/DashboardAnpassad", state: {DashId: ndate.results.currentCustomDashboard.id}})
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("addCustomDashboard2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_ADD_DASHBOARD_CUSTOM, payload: ndate.error});
        }
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_ADD_DASHBOARD_CUSTOM, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        }
        
      });
   }
 }
export const saveCustomDashboard = (Userid,Afid, layout, Dashboard) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_DASHBOARD_CUSTOM});
     axios.put('kontos/DashBoard/custom',
     { body:encrypt(JSON.stringify({Userid:Userid,Afid:Afid,layout:layout, Dashboard:Dashboard})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("saveCustomDashboard1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_UPDATE_DASHBOARD_CUSTOM, payload: ndate.results});
          dispatch(getCustomDashboard(Userid,Afid, Dashboard.id))
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("saveCustomDashboard2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UPDATE_DASHBOARD_CUSTOM, payload: ndate.error});
        }
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_DASHBOARD_CUSTOM, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        }
        
      });
   }
 }
export const saveCustomDashboardByMeta = (Userid,Afid, Meta, Value, DashId) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_DASHBOARD_CUSTOM});
     axios.put('kontos/DashBoard/customM',
     { body:encrypt(JSON.stringify({Userid:Userid,Afid:Afid,Meta:Meta, Value:Value, DashId:DashId})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("saveCustomDashboard1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_UPDATE_DASHBOARD_CUSTOM, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("saveCustomDashboard2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UPDATE_DASHBOARD_CUSTOM, payload: ndate.error});
        }
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_DASHBOARD_CUSTOM, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        }
        
      });
   }
 }

export const getCustomDashboard = (Userid,Afid, DashId) =>{
   //const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_GET_DASHBOARD_CUSTOM});
      axios.get('kontos/DashBoard/custom',
      { params:encrypt(JSON.stringify({Userid:Userid,Afid:Afid,DashId:DashId})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getCustomDashboard1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_DASHBOARD_CUSTOM, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getCustomDashboard2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_DASHBOARD_CUSTOM, payload: ndate.error});
        }
       })
       .catch(function (error) {
         dispatch({type: ON_ERROR_GET_DASHBOARD_CUSTOM, payload: error.message});
         console.log("Error****:", error.message);
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
         
       });
    }
  }
  export const deleteCustomDashboard = (Userid,Afid, DashId) =>{
    //const jwt =  JSON.parse(localStorage.token);
      return (dispatch) => {
        dispatch({type: ON_START_DELETE_DASHBOARD_CUSTOM});
        axios.delete('kontos/DashBoard/custom',
        { params:encrypt(JSON.stringify({Userid:Userid,Afid:Afid,DashId:DashId})), 
        /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
        ).then((data) => {
          if(data.data.success){
            let endata = decrypt(data.data.encryptedData,data.data.iv)
            console.log("deleteCustomDashboard1: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: ON_DELETE_DASHBOARD_CUSTOM, payload: ndate.results});
          }
          else{
            let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
            console.log("deleteCustomDashboard2: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: ON_ERROR_DELETE_DASHBOARD_CUSTOM, payload: ndate.error});
          }
        })
        .catch(function (error) {
          dispatch({type: ON_ERROR_DELETE_DASHBOARD_CUSTOM, payload: error.message});
          console.log("Error****:", error.message);
          if(error.message === "Network Error"){
              //reload and remove token 
              //dispatch(userSignOut())
          }
          
        });
      }
    }
export const getCustomDashboardList = (Userid,Afid) =>{
   //const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_GET_DASHBOARD_CUSTOM_LIST});
      axios.get('kontos/DashBoard/customL',
      { params:encrypt(JSON.stringify({Userid:Userid,Afid:Afid})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getCustomDashboardList1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_DASHBOARD_CUSTOM_LIST, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getCustomDashboardList2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_DASHBOARD_CUSTOM_LIST, payload: ndate.error});
        }
       })
       .catch(function (error) {
         dispatch({type: ON_ERROR_GET_DASHBOARD_CUSTOM_LIST, payload: error.message});
         console.log("Error****:", error.message);
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
         
       });
    }
  }

  export const removeCustomDashboard = (Userid,Afid, DashId) =>{
    //const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_REMOVE_DASHBOARD_CUSTOM});
       axios.delete('kontos/DashBoard/custom',
       { params:encrypt(JSON.stringify({Userid:Userid,Afid:Afid,DashId:DashId})), 
       /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
        ).then((data) => {
          if(data.data.success){
            let endata = decrypt(data.data.encryptedData,data.data.iv)
            console.log("getCustomDashboardList1: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: ON_REMOVE_DASHBOARD_CUSTOM, payload: ndate.results});
          }
          else{
            let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
            console.log("getCustomDashboardList2: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: ON_ERROR_REMOVE_DASHBOARD_CUSTOM, payload: ndate.error});
          }
        })
        .catch(function (error) {
          dispatch({type: ON_ERROR_REMOVE_DASHBOARD_CUSTOM, payload: error.message});
          console.log("Error****:", error.message);
          if(error.message === "Network Error"){
             //reload and remove token 
             //dispatch(userSignOut())
          }
          
        });
     }
   }

   //Dashboard Competition
export const addDashboardCompetition = (Userid,Afid, Competition, file, isFrom) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_ADD_DASHBOARD_COMPETITION});
     const formData = new FormData()

     formData.append('files[]', file)
     formData.append('Userid', Userid)
     formData.append('Afid', Afid)
     formData.append('name', Competition.name)
     formData.append('compStart', Competition.compStart)
     formData.append('compEnd', Competition.compEnd)
     formData.append('compEndSum', Competition.compEndSum)
     formData.append('description', Competition.description)
     formData.append('type', Competition.type)
     formData.append('typeopt', Competition.typeopt)
     formData.append('intervalltype', Competition.intervalltype)
     formData.append('_show', Competition._show)
     formData.append('deltagare', JSON.stringify(Competition.deltagare))
     formData.append('compTypes', JSON.stringify(Competition.compTypes))


     axios.post('kontos/DashBoard/competition',
     formData,
      { 
        body: {
          Userid:Userid,
          Afid:Afid,
          name: Competition.name,
          compStart: Competition.compStart,
          compEnd: Competition.compEnd,
          compEndSum: Competition.compEndSum,
          description: Competition.description,
          type: Competition.type,
          typeopt: Competition.typeopt,
          intervalltype: Competition.intervalltype,
          _show: Competition._show,
          deltagare: JSON.stringify(Competition.deltagare),
          compTypes: JSON.stringify(Competition.compTypes),
        }, 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
      ).then(({data}) => {
       console.log("addDashboardCompetition: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_ADD_DASHBOARD_COMPETITION, payload: data.results});
          if(isFrom === 1) {
            history.push({pathname:"/app/DashboardTavlingV2", state: {CompId: data.results.currentDashboardCompetition.id}})
          }
          else {
            history.push({pathname:"/app/DashboardTavling", state: {CompId: data.results.currentDashboardCompetition.id}})
          }
        } else {
          dispatch({type: ON_ERROR_ADD_DASHBOARD_COMPETITION, payload: data.error});
        }
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_ADD_DASHBOARD_COMPETITION, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        }
        
      });
   }
 }
export const saveDashboardCompetition = (Userid, Afid, Competition, file) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_DASHBOARD_COMPETITION});

     const formData = new FormData()

     console.log(Competition)

     formData.append('files[]', file)
     formData.append('Userid', Userid)
     formData.append('Afid', Afid)
     formData.append('name', Competition.Name)
     formData.append('compStart', Competition.compStart)
     formData.append('compEnd', Competition.compEnd)
     formData.append('compEndSum', Competition.compEndSum)
     formData.append('description', Competition.description)
     formData.append('deltagare', JSON.stringify(Competition.deltagare))
     formData.append('compTypes', JSON.stringify(Competition.compTypes))
     formData.append('type', Competition.type)
     formData.append('typeopt', Competition.typeopt)
     formData.append('intervalltype', Competition.intervalltype)
     formData.append('_show', Competition._show)
     formData.append('id', Competition.id)
     formData.append('imageUrl', Competition.imageUrl)


     axios.put('kontos/DashBoard/competition', 
      formData,
      { 
        body: {
          Userid:Userid,
          Afid:Afid,
          name: Competition.Name,
          compStart: Competition.compStart,
          compEnd: Competition.compEnd,
          compEndSum: Competition.compEndSum,
          description: Competition.description,
          deltagare: JSON.stringify(Competition.deltagare),
          compTypes: JSON.stringify(Competition.compTypes),
          type: Competition.type,
          typeopt: Competition.typeopt,
          intervalltype: Competition.intervalltype,
          _show: Competition._show,
          id: Competition.id,
          imageUrl: Competition.imageUrl,
        }, 
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
      ).then(({data}) => {
       console.log("saveDashboardCompetition: ", data);
        if (data.results) {
         // dispatch({type: FETCH_ALL_CONTACT});
          dispatch({type: ON_UPDATE_DASHBOARD_COMPETITION, payload: data.results});
        } else {
          dispatch({type: ON_ERROR_UPDATE_DASHBOARD_COMPETITION, payload: data.error});
        }
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_DASHBOARD_COMPETITION, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        }
        
      });
   }
 }
export const saveDashboardCompetitionByMeta = (Userid, Afid, Meta, Value, DashId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_DASHBOARD_COMPETITION});
     axios.put('kontos/DashBoard/competitionM', 
      { 
        body: encrypt(JSON.stringify({
          Userid:Userid,
          Afid:Afid,
          Meta:Meta,
          Value:Value, 
          DashId:DashId
        }))},{ 
        headers: {
          'Authorization':   `Bearer ${jwt}`
        }
      }
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("saveDashboardCompetition1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_UPDATE_DASHBOARD_COMPETITION, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("saveDashboardCompetition2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UPDATE_DASHBOARD_COMPETITION, payload: ndate.error});
        }       
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_DASHBOARD_COMPETITION, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())
        }
        
      });
   }
 }

export const getDashboardCompetition = (Userid,Afid, CompId) =>{
   //const jwt =  JSON.parse(localStorage.token);
		const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
		console.log(timezone, 'timezone')
    return (dispatch) => {
      dispatch({type: ON_START_GET_DASHBOARD_COMPETITION});
      axios.get('kontos/DashBoard/competition',
      { params:encrypt(JSON.stringify({Userid:Userid,Afid:Afid,CompId:CompId, timezone})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getDashboardCompetition1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_DASHBOARD_COMPETITION, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getDashboardCompetition2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_DASHBOARD_COMPETITION, payload: ndate.error});
        }
       })
       .catch(function (error) {
         dispatch({type: ON_ERROR_GET_DASHBOARD_COMPETITION, payload: error.message});
         console.log("Error****:", error.message);
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
         
       });
    }
  }
  export const deleteDashboardCompetition = (Userid,Afid, CompId) =>{
    //const jwt =  JSON.parse(localStorage.token);
      return (dispatch) => {
        dispatch({type: ON_START_DELETE_DASHBOARD_COMPETITION});
        axios.delete('kontos/DashBoard/competition',
        { params:encrypt(JSON.stringify({Userid:Userid,Afid:Afid,CompId:CompId})), 
        /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
        ).then((data) => {
          if(data.data.success){
            let endata = decrypt(data.data.encryptedData,data.data.iv)
            console.log("deleteDashboardCompetition1: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: ON_DELETE_DASHBOARD_COMPETITION, payload: ndate.results});
          }
          else{
            let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
            console.log("deleteDashboardCompetition2: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: ON_ERROR_DELETE_DASHBOARD_COMPETITION, payload: ndate.error});
          }
        })
        .catch(function (error) {
          dispatch({type: ON_ERROR_DELETE_DASHBOARD_COMPETITION, payload: error.message});
          console.log("Error****:", error.message);
          if(error.message === "Network Error"){
              //reload and remove token 
              //dispatch(userSignOut())
          }
          
        });
      }
    }
export const getDashboardCompetitionList = (Userid,Afid) =>{
   //const jwt =  JSON.parse(localStorage.token);
    return (dispatch) => {
      dispatch({type: ON_START_GET_DASHBOARD_COMPETITION_LIST});
      axios.get('kontos/DashBoard/competitionL',
      { params:encrypt(JSON.stringify({Userid:Userid,Afid:Afid})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getDashboardCompetitionList1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_DASHBOARD_COMPETITION_LIST, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getDashboardCompetitionList2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_DASHBOARD_COMPETITION_LIST, payload: ndate.error});
        }
       })
       .catch(function (error) {
         dispatch({type: ON_ERROR_GET_DASHBOARD_COMPETITION_LIST, payload: error.message});
         console.log("Error****:", error.message);
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
         
       });
    }
  }

  export const removeDashboardCompetition = (Userid,Afid, CompId) =>{
    //const jwt =  JSON.parse(localStorage.token);
     return (dispatch) => {
       dispatch({type: ON_START_REMOVE_DASHBOARD_COMPETITION});
       axios.delete('kontos/DashBoard/competition',
       { params:encrypt(JSON.stringify({Userid:Userid,Afid:Afid,CompId:CompId})), 
       /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
        ).then((data) => {
          if(data.data.success){
            let endata = decrypt(data.data.encryptedData,data.data.iv)
            console.log("removeDashboardCompetition1: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: ON_REMOVE_DASHBOARD_COMPETITION, payload: ndate.results});
          }
          else{
            let Data = isUndefined(data.data.error)?data.data:data.data.error
            let endata = decrypt(Data.encryptedData,Data.iv)
            console.log("removeDashboardCompetition2: ", endata);
            let ndate = JSON.parse(endata)
            dispatch({type: ON_ERROR_REMOVE_DASHBOARD_COMPETITION, payload: ndate.error});
          }
        })
        .catch(function (error) {
          dispatch({type: ON_ERROR_REMOVE_DASHBOARD_COMPETITION, payload: error.message});
          console.log("Error****:", error.message);
          if(error.message === "Network Error"){
             //reload and remove token 
             //dispatch(userSignOut())
          }
          
        });
     }
   }
   export const postMessageDashboardCompetition = (Afid, Userid, CompId, msg) => {
    const jwt =  JSON.parse(localStorage.token);
    return(dispatch) => {
      dispatch({type: ON_START_POST_CHAT_DASHBOARD_COMPETITION})
      axios.post('kontos/DashBoard/postMessageDashboardCompetition', {
        body: encrypt(JSON.stringify({Afid, Userid, CompId, msg}))
        ,}, 
        {
        headers: {
          'Authorization': `Bearer ${jwt}`
        }
      }).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("updateDashboardTVDeviceVy: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_POST_CHAT_DASHBOARD_COMPETITION, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("updateDashboardTVDeviceVy: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_POST_CHAT_DASHBOARD_COMPETITION, payload: ndate.error});
        }
     
      }).catch(err => {
        dispatch({type: ON_ERROR_POST_CHAT_DASHBOARD_COMPETITION})
        console.log(err)
      })
    }
  }

//getVunnenMonthByUserid
export const getVunnenMonthByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0,Taggs = [],callBackFunc) =>{
  console.log(FilterOption)
   //const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_FETCH_VUNNEN_MONTH});
      await axios.get('kontos/DashBoard/getVMBU',
      { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad,Taggs})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getVunnenMonthByUserid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_VUNNEN_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getVunnenMonthByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_VUNNEN_MONTH, payload: ndate.error});
        }
       })
       .catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_VUNNEN_MONTH, payload: error.message});
         console.log("Error****:", error.message);
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
         
       });
    }
  }
export const getSummaBillingAvtal = (userid,Afid,FilterOption, intervaltype = 1,abonnamangeSetting=0,Anpassad = 0,Taggs = [],callBackFunc) =>{
  console.log(FilterOption)
   //const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_FETCH_SUMMA_BILLING_AVTAL});
      await axios.get('kontos/DashBoard/getSBA',
      { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad,Taggs,abonnamangeSetting})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getSummaBillingAvtal1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_SUMMA_BILLING_AVTAL, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getSummaBillingAvtal2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_SUMMA_BILLING_AVTAL, payload: ndate.error});
        }
       })
       .catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_SUMMA_BILLING_AVTAL, payload: error.message});
         console.log("Error****:", error.message);
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
         
       });
    }
  }
export const getSummaAvtalAbonn = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0,Taggs=[],callBackFunc) =>{
  console.log(FilterOption)
   //const jwt =  JSON.parse(localStorage.token);
   
    return async (dispatch) => {
      dispatch({type: ON_START_FETCH_SUMMA_ABONNEMANG_AVTAL});
      await axios.get('kontos/DashBoard/getSBATB',
      { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad,Taggs})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getSummaAvtalAbonn1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_SUMMA_ABONNEMANG_AVTAL, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getSummaAvtalAbonn2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_SUMMA_ABONNEMANG_AVTAL, payload: ndate.error});
        }
       })
       .catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_SUMMA_ABONNEMANG_AVTAL, payload: error.message});
         console.log("Error****:", error.message);
         if(error.message === "Network Error"){
            //reload and remove token 
            //dispatch(userSignOut())
         }
         
       });
    }
  }
//getAbonnemangVardeByUserid
export const getAbonnemangVardeByUserid = (userid,Afid,FilterOption, intervaltype = 1 ,Anpassad = 0, Taggs=[], callBackFunc) =>{
   //const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_FETCH_ABO_VUNNEN_MONTH});
      await axios.get('kontos/DashBoard/getABVMBU',
      { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,intervaltype,Anpassad,Taggs})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAbonnemangVardeByUserid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_ABO_VUNNEN_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAbonnemangVardeByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_ABO_VUNNEN_MONTH, payload: ndate.error});
        }
        
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_ABO_VUNNEN_MONTH, payload: error.message});
         console.log("Error****:", error.message);
         
         if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       });
    }
  }
export const getAbonnemangVardeNByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0,Taggs=[], callBackFunc) =>{
   //const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_FETCH_ABON_VUNNEN_MONTH});
      await axios.get('kontos/DashBoard/getABVMBUN',
      { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,intervaltype,Anpassad,Taggs})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAbonnemangVardeByUserid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_ABON_VUNNEN_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAbonnemangVardeByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_ABON_VUNNEN_MONTH, payload: ndate.error});
        }
        
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_ABON_VUNNEN_MONTH, payload: error.message});
         console.log("Error****:", error.message);
         
         if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       });
    }
  }
  
//getOrderVardeByUserid
export const getOrderVardeByUserid = (userid,Afid,FilterOption, intervaltype = 1,orderVardeSetting=0,Anpassad = 0,Taggs=[], callBackFunc) =>{
   //const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_FETCH_ORDER_VUNNEN_MONTH});
      await axios.get('kontos/DashBoard/getORVMBU',
      { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad,Taggs,orderVardeSetting})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getOrderVardeByUserid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_ORDER_VUNNEN_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getOrderVardeByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_ORDER_VUNNEN_MONTH, payload: ndate.error});
        }
        
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_ORDER_VUNNEN_MONTH, payload: error.message});
         console.log("Error****:", error.message);
         
         if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       });
    }
  }
//getAntalKlaraAktByUserid  
export const getAntalKlaraAktByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad= 0,callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_KLARA_AKTIVITET_MONTH});
     await axios.get('kontos/DashBoard/getKLAVMBU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAntalKlaraAktByUserid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_KLARA_AKTIVITET_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAntalKlaraAktByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_KLARA_AKTIVITET_MONTH, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_KLARA_AKTIVITET_MONTH, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
//getSkProspektByUserid  
export const getSkProspektByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad =0 , callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_SKAPAD_PROSPEKT_MONTH});
     await axios.get('kontos/DashBoard/getSKPROVMBU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getSkProspektByUserid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_SKAPAD_PROSPEKT_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getSkProspektByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_SKAPAD_PROSPEKT_MONTH, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_SKAPAD_PROSPEKT_MONTH, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
//getSkProspektByUserid  
export const getAkAvtalByUserid = (userid,Afid,FilterOption, intervaltype = 1, Anpassad = 0,Taggs = [], callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AKTIVA_AVTAL});
     await axios.get('kontos/DashBoard/getAAVTAL',
    { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad,Taggs})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAkAvtalByUserid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AKTIVA_AVTAL, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAkAvtalByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_AKTIVA_AVTAL, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_AKTIVA_AVTAL, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
//getSkProspektByUserid  
export const getAAVBTableAbonn = (userid,Afid,FilterOption, intervaltype = 1, Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTAL_TABLE_ABONN});
     await axios.get('kontos/DashBoard/getAAVBTableAbonn',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAkAvtalByUserid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AVTAL_TABLE_ABONN, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAkAvtalByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_AVTAL_TABLE_ABONN, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_AVTAL_TABLE_ABONN, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 //getAAVINBTableAbonn
export const getAAVINBTableAbonn = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0,Taggs=[], callback) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTALINVOICING_TABLE_ABONN});
     await axios.get('kontos/DashBoard/getAAVINBTableAbonn',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad,Taggs})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then(data => {

       console.log("getAAVINBTableAbonn: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAAVINBTableAbonn1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AVTALINVOICING_TABLE_ABONN, payload: ndate.results});
        if(callback){callback(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAAVINBTableAbonn2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_AVTALINVOICING_TABLE_ABONN, payload: ndate.error});
      }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_AVTALINVOICING_TABLE_ABONN, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 //
 export const getAAVBTable = (userid,Afid,FilterOption, intervaltype = 1,AvtalType="Alla",KalkylType ="Alla",Anpassad = 0,Taggs=[],callback) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTAL_TABLE_ALL});
     await axios.get('kontos/DashBoard/getAAVBTable',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,
      AvtalType,KalkylType,Anpassad,Taggs
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then( data  => {
       console.log("getAAVBTable: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAAVBTable1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AVTAL_TABLE_ALL, payload: ndate.results});
        if(callback){callback(ndate.results)}
       }
       else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAAVBTable2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_AVTAL_TABLE_ALL, payload: ndate.error});
       }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_AVTAL_TABLE_ALL, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
//  ON_START_FETCH_AVTAL_TABLE_ENGÅNG,ON_FETCH_AVTAL_TABLE_ENGÅNG,ON_ERROR_FETCH_AVTAL_TABLE_ENGÅNG,
export const getAAVBTableEngang = (userid,Afid,FilterOption, intervaltype = 1, Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTAL_TABLE_ENGÅNG});
     await axios.get('kontos/DashBoard/getAAVBTableEngang',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAAVBTableEngang1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AVTAL_TABLE_ENGÅNG, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAAVBTableEngang2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_AVTAL_TABLE_ENGÅNG, payload: ndate.error});
        }
       console.log("getAAVBTableEngang: ", data);
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_AVTAL_TABLE_ENGÅNG, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 
//  ON_START_FETCH_AVTAL_GRAPH_VALUE_REMAINING,ON_FETCH_AVTAL_GRAPH_VALUE_REMAINING,ON_ERROR_FETCH_AVTAL_GRAPH_VALUE_REMAINING,
export const getAAVGraphRemaining = (Afid,userid,FilterOption, intervaltype = 1, Anpassad = 0,Taggs=[], callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTAL_GRAPH_VALUE_REMAINING});
     await axios.get('kontos/DashBoard/getAAVGraphRemaining',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad,Taggs})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAAVGraphRemaining1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AVTAL_GRAPH_VALUE_REMAINING, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAAVGraphRemaining2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_AVTAL_GRAPH_VALUE_REMAINING, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_AVTAL_GRAPH_VALUE_REMAINING, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
//  ON_START_FETCH_AVTAL_SUM_VALUE_REMAINING,ON_FETCH_AVTAL_SUM_VALUE_REMAINING,ON_ERROR_FETCH_AVTAL_SUM_VALUE_REMAINING,
export const getAAVSumRemaining = (Afid,userid,FilterOption, intervaltype = 1, Anpassad = 0,Taggs=[], callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTAL_SUM_VALUE_REMAINING});
     await axios.get('kontos/DashBoard/getAAVSumRemaining',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad,Taggs})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAAVSumRemaining1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AVTAL_SUM_VALUE_REMAINING, payload: ndate.results});
          if(callBackFunc){callBackFunc(data.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAAVSumRemaining2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_AVTAL_SUM_VALUE_REMAINING, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_AVTAL_SUM_VALUE_REMAINING, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }

//getSummaOffertByUserid  
export const getSummaOffertByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0,callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async(dispatch) => {
     dispatch({type: ON_START_FETCH_SUMMA_OFFERT_MONTH});
    await axios.get('kontos/DashBoard/getSUMOFVMBU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getSkProspektByUserid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_SUMMA_OFFERT_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getSkProspektByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_SUMMA_OFFERT_MONTH, payload: ndate.error});
        }
       console.log(": ", data);
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_SUMMA_OFFERT_MONTH, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 
//getAvslutaAffarByUserid
export const getAvslutaAffarByUserid = (userid,Afid,FilterOption, intervaltype = 1, all,Page=0,Anpassad = 0,Taggs=[],callBackFunc, DashView='sales') =>{
   //const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      dispatch({type: ON_START_FETCH_AVSLUTA_AFFAR});
      await axios.get('kontos/DashBoard/getAFLBU',
      { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype, all,Page,Taggs,Anpassad, DashView})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        console.log("getAvslutaAffarByUserid1: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("updateDashboardTVDeviceVy: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AVSLUTA_AFFAR, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAvslutaAffarByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_AVSLUTA_AFFAR, payload: ndate.error});
        }
       
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_AVSLUTA_AFFAR, payload: error.message});
         console.log("Error****:", error.message);
         
         if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       });
    }
  }
//getDashOrderListByUserid
export const getDashOrderListByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad=0,Taggs = [],callBackFunc) =>{
   //const jwt =  JSON.parse(localStorage.token);
    return async(dispatch) => {
      dispatch({type: ON_START_FETCH_DASHORDER_LIST});
      await axios.get('kontos/DashBoard/getOLBU',
      { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Taggs,Anpassad})), 
      /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
       ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getDashOrderListByUserid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_DASHORDER_LIST, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getDashOrderListByUserid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_DASHORDER_LIST, payload: ndate.error});
        }
      
       }).catch(function (error) {
         dispatch({type: ON_ERROR_FETCH_DASHORDER_LIST, payload: error.message});
         console.log("Error****:", error.message);
         
         if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       }
       });
    }
  }
//getMoteByUserid
export const getMoteByUserid = (userid,Afid,FilterOption, intervaltype = 0,Anpassad = 0,callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_MOTE_MONTH});
    await axios.get('kontos/DashBoard/getBMBU',
    { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,intervaltype,Anpassad})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMoteByUserid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_MOTE_MONTH, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getMoteByUserid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_MOTE_MONTH, payload: ndate.error});
      }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_MOTE_MONTH, payload: error.message});
       console.log("Error****:", error.message);
       
       if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     }
     });
  }
}  
export const getMoteLobbyByUserid = (userid,Afid) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_MOTE_MONTH});
    axios.get('kontos/DashBoard/getBMBULOBBY',
    { params:encrypt(JSON.stringify({userid:userid,Afid:Afid})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMoteByUserid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_MOTE_MONTH, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getMoteByUserid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_MOTE_MONTH, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_MOTE_MONTH, payload: error.message});
       console.log("Error****:", error.message);
       
       if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     }
     });
  }
}  
//getVunnenChartByUserid
export const getVunnenChartByUserid = (userid,Afid,FilterOption,Anpassad = 0,Taggs = [],callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_VUNNEN_CHART});
    await axios.get('kontos/DashBoard/getVYCBU',
    { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,Anpassad,Taggs})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getVunnenChartByUserid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_VUNNEN_CHART, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getVunnenChartByUserid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_VUNNEN_CHART, payload: ndate.error});
      }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_VUNNEN_CHART, payload: error.message});
       console.log("Error****:", error.message);
       
       if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     }
     });
  }
}
//getVunnenChartByAFid
export const getVunnenChartByAFid = (userid,Afid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_VUNNEN_CHART});
    await axios.get('kontos/DashBoard/getVYCBUAF',
    { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getVunnenChartByAFid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_VUNNEN_CHART, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getVunnenChartByAFid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_VUNNEN_CHART, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_VUNNEN_CHART, payload: error.message});
       console.log("Error****:", error.message);
       
       if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     }
     });
  }
}
//getVunnenMonthChartByUserid
export const getVunnenMonthChartByUserid = (userid,Afid,FilterOption, intervaltype = 0,Anpassad=0,Taggs = [],callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_VUNNEN_MONTH_CHART});
    await axios.get('kontos/DashBoard/getVMCBU',
    { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,intervaltype,Anpassad,Taggs})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getVunnenMonthChartByUserid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_VUNNEN_MONTH_CHART, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getVunnenMonthChartByUserid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_VUNNEN_MONTH_CHART, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_VUNNEN_MONTH_CHART, payload: error.message});
       console.log("Error****:", error.message);
       
       if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     }
     });
  }
}
//getAktiviterByUserid
export const getAktiviterByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0, callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async(dispatch) => {
    dispatch({type: ON_START_FETCH_AKTIVITITER_CHART});
   await axios.get('kontos/DashBoard/getAKCBU',
    { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAktiviterByUserid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AKTIVITITER_CHART, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAktiviterByUserid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_AKTIVITITER_CHART, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_AKTIVITITER_CHART, payload: error.message});
       console.log("Error****:", error.message);
       
       if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     }
     });
  }
}
//getDashboardFilter
export const getDashboardFilter = (Afid,userid,Filterstate) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_DASHBOARD_FILTER});
    axios.get('kontos/DashBoard/Filter',
    { params:encrypt(JSON.stringify({
      userid:userid,
      Afid:Afid,
      Filterstate:Filterstate
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAktiviterByUserid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_DASHBOARD_FILTER, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAktiviterByUserid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_DASHBOARD_FILTER, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_FETCH_DASHBOARD_FILTER, payload: error.message});
       console.log("Error****:", error.message);
       
       if(error.message === "Network Error"){
        //reload and remove token 
        //dispatch(userSignOut())
     }
     });
  }
}

//getBestListDialerByAfid
export const getBestListDialerByAfid = (Afid,userid,Filterstate) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_BESTLIST_DIALER_BYAFID});
    await axios.get('kontos/DashBoard/BLDByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      Filterstate:Filterstate
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getBestListDialerByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_BESTLIST_DIALER_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getBestListDialerByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_BESTLIST_DIALER_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BESTLIST_DIALER_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getAktiverKunderByAfid
export const getAktiverKunderByAfid = (Afid,userid,Filterstate) =>{
  console.log(Filterstate,"Filterstate")
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_AKTIVAKUNDER_DIALER_BYAFID});
    await axios.get('kontos/DashBoard/AKDByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      Filterstate:Filterstate
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAktiverKunderByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AKTIVAKUNDER_DIALER_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAktiverKunderByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AKTIVAKUNDER_DIALER_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AKTIVAKUNDER_DIALER_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getBokadMoteDialerByAfid
export const getBokadMoteDialerByAfid = (Afid,userid,Filterstate) =>{

 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_BOKAMOTE_DIALER_BYAFID});
    await axios.get('kontos/DashBoard/BMDByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      Filterstate:Filterstate
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getBokadMoteDialerByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_BOKAMOTE_DIALER_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getBokadMoteDialerByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_BOKAMOTE_DIALER_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_BOKAMOTE_DIALER_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getSalTableDialerByAfid
export const getSalTableDialerByAfid = (Afid,userid,Filterstate) =>{

 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_SALTABLE_DIALER_BYAFID});
    await axios.get('kontos/DashBoard/SLTDByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      Filterstate:Filterstate,
      userid:userid
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getSalTableDialerByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_SALTABLE_DIALER_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getSalTableDialerByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_SALTABLE_DIALER_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_SALTABLE_DIALER_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

// ON_START_FETCH_LYNES_SAMTAL_BYAFID,ON_FETCH_LYNES_SAMTAL_BYAFID,ON_ERROR_LYNES_SAMTAL_BYAFID,
export const getSalTableLynesSamtalByAfid = (userid,Afid,Filterstate, intervaltype = 1 , Anpassad = 0, callBackFunc) =>{

 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_LYNES_SAMTAL_BYAFID});
    await axios.get('kontos/DashBoard/SLTLSByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      Filterstate:Filterstate,
      userid:userid,
      intervaltype:intervaltype,
      Anpassad
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getSalTableLynesSamtalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_LYNES_SAMTAL_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getSalTableLynesSamtalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_LYNES_SAMTAL_BYAFID, payload: ndate.error});
      }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_LYNES_SAMTAL_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const getAntalLynesSamtalByAfid = (userid,Afid,Filterstate , intervaltype = 1, Anpassad = 0, callBackFunc) =>{

 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_LYNES_SAMTAL_ANTAL_BYAFID});
    await axios.get('kontos/DashBoard/SATLSByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      Filterstate:Filterstate,
      userid:userid,
intervaltype:intervaltype,
Anpassad
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAntalLynesSamtalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_LYNES_SAMTAL_ANTAL_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAntalLynesSamtalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_LYNES_SAMTAL_ANTAL_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_LYNES_SAMTAL_ANTAL_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}

export const getAvgLynesSamtalDurByAfid = (userid,Afid,Filterstate , intervaltype = 1, Anpassad = 0, callBackFunc) =>{

 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID});
    await axios.get('kontos/DashBoard/SLAvgByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      Filterstate:Filterstate,
      userid:userid,
intervaltype:intervaltype,
Anpassad
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAvgLynesSamtalDurByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_LYNES_SAMTAL_AVG_DUR_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAvgLynesSamtalDurByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_LYNES_SAMTAL_AVG_DUR_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_LYNES_SAMTAL_AVG_DUR_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const getTableLynesSamtalByAfid = (userid,Afid,Filterstate , intervaltype = 1, Anpassad = 0, callBackFunc) =>{

 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_LYNES_SAMTAL_TABLE_BYAFID});
    await axios.get('kontos/DashBoard/SLTvgByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      Filterstate:Filterstate,
      userid:userid,
intervaltype:intervaltype,
Anpassad
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getTableLynesSamtalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_LYNES_SAMTAL_TABLE_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getTableLynesSamtalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_LYNES_SAMTAL_TABLE_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_LYNES_SAMTAL_TABLE_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
export const getGraphLynesSamtalByAfid = (Afid,userid,Filterstate, Anpassad = 0, callBackFunc ) =>{

 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_LYNES_SAMTAL_GRAPH_BYAFID});
    await axios.get('kontos/DashBoard/SLGvgByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      Filterstate:Filterstate,
userid:userid,Anpassad
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getGraphLynesSamtalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_LYNES_SAMTAL_GRAPH_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getGraphLynesSamtalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_LYNES_SAMTAL_GRAPH_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_LYNES_SAMTAL_GRAPH_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getAvslutningDialerByAfid
export const getAvslutningDialerByAfid = (Afid,userid,Filterstate) =>{

 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_AVSLUT_DIALER_BYAFID});
    await axios.get('kontos/DashBoard/AVSTDByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      Filterstate:Filterstate,
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAvslutningDialerByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AVSLUT_DIALER_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAvslutningDialerByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AVSLUT_DIALER_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AVSLUT_DIALER_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getStatusDialerByAfid
export const getStatusDialerByAfid = (Afid,userid,Filterstate) =>{

 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_STATUS_DIALER_BYAFID});
    await axios.get('kontos/DashBoard/STUSTDByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      Filterstate:Filterstate,
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getStatusDialerByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_STATUS_DIALER_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getStatusDialerByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_STATUS_DIALER_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_STATUS_DIALER_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getAktiviterDailerByAfid
export const getAktiviterDailerByAfid = (Afid,userid,Filterstate) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_AKTIVITED_DIALER_BYAFID});
    await axios.get('kontos/DashBoard/AKDUSTDByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      Filterstate:Filterstate,
      userid:userid
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAktiviterDailerByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AKTIVITED_DIALER_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAktiviterDailerByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AKTIVITED_DIALER_BYAFID, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AKTIVITED_DIALER_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
  }
}
//getTopListSalByAfid
export const getTopListSalByAfid = (Afid,userid,FilterOption, intervaltype = 1,Datum = 0, Anpassad = 0,Taggs=[], callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_TOPLIST_SAL_BYAFID}); 
    await axios.get('kontos/DashBoard/TPLSByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
      intervaltype:intervaltype,
Datum:Datum,
      Anpassad,
      Taggs
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getTopListSalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_TOPLIST_SAL_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getTopListSalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_TOPLIST_SAL_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TOPLIST_SAL_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
// ON_START_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID,ON_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID,ON_ERROR_TOPLIST_PROBABILITY_VALUE_BYAFID,
export const getTopListSalProbByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID}); 
    await axios.get('kontos/DashBoard/TPLSPByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getTopListSalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_TOPLIST_PROBABILITY_VALUE_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getTopListSalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_TOPLIST_PROBABILITY_VALUE_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TOPLIST_PROBABILITY_VALUE_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getTopListSalAntalByAfid
export const getTopListSalAntalByAfid = (Afid,userid,FilterOption, intervaltype = 1,Datum=0, Anpassad=0,Taggs = [],callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_TOPLIST_SALANTAL_BYAFID});
    await axios.get('kontos/DashBoard/TPLSANByAf',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      FilterOption:FilterOption,
      intervaltype:intervaltype,
      Datum:Datum,
Anpassad,Taggs
})), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getTopListSalAntalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_TOPLIST_SALANTAL_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getTopListSalAntalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_TOPLIST_SALANTAL_BYAFID, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TOPLIST_SALANTAL_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getAntalVSaldByAfid
export const getAntalVSaldByAfid = (Afid,userid,FilterOption, intervaltype = 1,Datum = 0,Anpassad = 0, Taggs=[],callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AFFAR_SALANTAL_BYAFID});
    await axios.get('kontos/DashBoard/ANVNAByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
      intervaltype:intervaltype,
      Datum:Datum,
Anpassad,Taggs
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAntalVSalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AFFAR_SALANTAL_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAntalVSalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AFFAR_SALANTAL_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AFFAR_SALANTAL_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getVSaldByAfid
export const getVSaldByAfid = (Afid,userid,FilterOption, intervaltype = 1,Datum =0,Anpassad = 0,Taggs=[], callBackFunc ) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AFFAR_SAL_BYAFID});
    await axios.get('kontos/DashBoard/VNAByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
      intervaltype:intervaltype,
Datum:Datum,Anpassad,Taggs
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAntalVSalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AFFAR_SAL_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAntalVSalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AFFAR_SAL_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AFFAR_SAL_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}

// ON_START_FETCH_AVTAL_VALUE_SAL_BYAFID,ON_FETCH_AVTAL_VALUE_SAL_BYAFID,ON_ERROR_AVTAL_VALUE_SAL_BYAFID,
export const getAvtalValueByAfid = (Afid,userid,FilterOption, intervaltype = 1, Anpassad = 0,Taggs=[], callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTAL_VALUE_SAL_BYAFID});
    await axios.get('kontos/DashBoard/AVByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
intervaltype:intervaltype,Anpassad,Taggs
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAvtalValueByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AVTAL_VALUE_SAL_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAvtalValueByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AVTAL_VALUE_SAL_BYAFID, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AVTAL_VALUE_SAL_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}

export const getAvtalValueBillingByAfid = (Afid,userid,FilterOption, intervaltype = 1, Anpassad = 0, Taggs=[], callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID});
    await axios.get('kontos/DashBoard/AVBILLByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
      intervaltype:intervaltype,
Anpassad,Taggs
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAvtalValueBillingByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AVTAL_VALUE_BILLING_SAL_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAvtalValueBillingByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AVTAL_VALUE_BILLING_SAL_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AVTAL_VALUE_BILLING_SAL_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
// ON_START_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,ON_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,ON_ERROR_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID,
export const getAvtalValueBillingYearByAfid = (Afid,userid,FilterOption, intervaltype = 1, Anpassad = 0,Taggs=[], callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID});
    await axios.get('kontos/DashBoard/AVBILLYByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
intervaltype:intervaltype,Anpassad,Taggs
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAvtalValueBillingYearByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAvtalValueBillingYearByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AVTAL_VALUE_BILLING_YEAR_SAL_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}

// ON_START_FETCH_AFFAR_PROBABILITY_SAL_BYAFID,ON_FETCH_AFFAR_PROBABILITY_SAL_BYAFID,ON_ERROR_AFFAR_PROBABILITY_SAL_BYAFID,
export const getVSaldProbByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_AFFAR_PROBABILITY_SAL_BYAFID});
    await axios.get('kontos/DashBoard/VNAPByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAntalVSalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AFFAR_PROBABILITY_SAL_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAntalVSalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AFFAR_PROBABILITY_SAL_BYAFID, payload: ndate.error});
      }
   
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AFFAR_PROBABILITY_SAL_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getTopListBokningByAfid
export const getTopListBokningByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_TOPLIST_BOK_BYAFID});
    await axios.get('kontos/DashBoard/TpLSBkByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getTopListBokningByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_TOPLIST_BOK_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getTopListBokningByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_TOPLIST_BOK_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TOPLIST_BOK_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getTopListBokningAntalByAfid
export const getTopListBokningAntalByAfid = (Afid,userid,FilterOption,intervaltype=1,Anpassad=0,callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID});
    await axios.get('kontos/DashBoard/TpLSBkANByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
      Anpassad
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getTopListBokningAntalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getTopListBokningAntalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
export const getTopListTaggarAntalByAfid = (Afid,userid,FilterOption, Taggar, tagStateKey, intervaltype = 1, Users, StartDate=null) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID});
    await axios.get('kontos/DashBoard/TpLSTaANByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
      Taggar:Taggar,
      Users:Users,
      intervaltype: intervaltype,
      StartDate: StartDate
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getTopListTaggarAntalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_TOPLIST_ANTAL_TAGGAR_BYAFID, payload: {
          ...ndate.results,
          tagStateKey
        }});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getTopListTaggarAntalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_TOPLIST_ANTAL_TAGGAR_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TOPLIST_ANTAL_TAGGAR_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
export const getTopListBokningGAntalByAfid = (Afid,userid,FilterOption,intervaltype = 1, Anpassad = 0, callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G});
    await axios.get('kontos/DashBoard/TpLSBkANByAfudB',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
      type:1,Anpassad
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getTopListBokningGAntalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_G, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getTopListBokningGAntalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_G, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_G, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
export const getTopListBokningBAntalByAfid = (Afid,userid,FilterOption,intervaltype = 1, Anpassad = 0, callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B});
    await axios.get('kontos/DashBoard/TpLSBkANByAfudB',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,
      type:0,Anpassad
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getTopListBokningGAntalByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_TOPLIST_ANTAL_BOK_BYAFID_B, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getTopListBokningGAntalByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_B, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TOPLIST_ANTAL_BOK_BYAFID_B, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getAntalBokmoteByAfid
export const getAntalBokmoteByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_ANTAL_BOK_BYAFID});
    await axios.get('kontos/DashBoard/ANBOKMByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAntalBokmoteByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_ANTAL_BOK_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAntalBokmoteByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ANTAL_BOK_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ANTAL_BOK_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
export const getAntalBokmoteByAfidUserid = (Afid,userid,FilterOption, intervaltype = 1,Anpassad = 0, callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_ANTAL_BOK_BYAFID});
    await axios.get('kontos/DashBoard/ANBOKMByAfudUserid',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid,Anpassad
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAntalBokmoteByAfidUserid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_ANTAL_BOK_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAntalBokmoteByAfidUserid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_ANTAL_BOK_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_ANTAL_BOK_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getKundtabelBokamoteByAfid
export const getKundtabelBokamoteByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_TABEL_BOK_BYAFID});
    await axios.get('kontos/DashBoard/TBBOKMByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getKundtabelBokamoteByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_TABEL_BOK_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getKundtabelBokamoteByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_TABEL_BOK_BYAFID, payload: ndate.error});
      }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_TABEL_BOK_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}

//getUtfalldiagramBMByAfid
export const getUtfalldiagramBMByAfid = (Afid,userid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
      dispatch({type: ON_START_FETCH_UTFALL_BOK_BUDGET_BYAFID});
      await axios.get('kontos/DashBoard/UTBMBOKMByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       FilterOption:FilterOption,
       userid:userid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramBMByAfid1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_UTFALL_BOK_BUDGET_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramBMByAfid2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UTFALL_BOK_BUDGET_BYAFID, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UTFALL_BOK_BUDGET_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getUtfalldiagramByAfid
export const getUtfalldiagramByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return (dispatch) => {
    dispatch({type: ON_START_FETCH_UTFALL_BOK_BYAFID});
    axios.get('kontos/DashBoard/UTBOKMByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      FilterOption:FilterOption,
      userid:userid
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getUtfalldiagramByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_UTFALL_BOK_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getUtfalldiagramByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UTFALL_BOK_BYAFID, payload: ndate.error});
      }    
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UTFALL_BOK_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getMontVunnenProspektByAfid
export const getMontVunnenProspektByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_MONTH_PROSPEKTD_BYAFID});
    await axios.get('kontos/DashBoard/MBPROMByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,FilterOption
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getMontVunnenProspektByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_MONTH_PROSPEKTD_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getMontVunnenProspektByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_MONTH_PROSPEKTD_BYAFID, payload: ndate.error});
      }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_MONTH_PROSPEKTD_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getKvartalVunnenProspektByAfid
export const getKvartalVunnenProspektByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_KVARTAL_PROSPEKTD_BYAFID});
    await axios.get('kontos/DashBoard/KBPROMByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,FilterOption
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getKvartalVunnenProspektByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_KVARTAL_PROSPEKTD_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getKvartalVunnenProspektByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_KVARTAL_PROSPEKTD_BYAFID, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_KVARTAL_PROSPEKTD_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getAntalVunnenByAfid
export const getAntalVunnenByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_VUNNENLIST_PROSPEKTD_BYAFID});
    await axios.get('kontos/DashBoard/VNLSPROByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,FilterOption
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAntalVunnenByAfid1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_VUNNENLIST_PROSPEKTD_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAntalVunnenByAfid2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_VUNNENLIST_PROSPEKTD_BYAFID, payload: ndate.error});
      }
     
     }).catch(function (error) {
       dispatch({type: ON_ERROR_VUNNENLIST_PROSPEKTD_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getVunnenListPByAfid
export const getVunnenListPByAfid = (Afid,userid,FilterOption,isDashBoard=0) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID});
    await axios.get('kontos/DashBoard/VKLSPROByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,FilterOption,isDashBoard
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getVunnenListPByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_VUNNENLISTK_PROSPEKTD_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getVunnenListPByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_VUNNENLISTK_PROSPEKTD_BYAFID, payload: ndate.error});
      }
   
     }).catch(function (error) {
       dispatch({type: ON_ERROR_VUNNENLISTK_PROSPEKTD_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getPipelineProsByAfid
export const getPipelineProsByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_PIPELINE_PROSPEKTD_BYAFID});
    await axios.get('kontos/DashBoard/PLPROByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,FilterOption
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getPipelineProsByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_PIPELINE_PROSPEKTD_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getPipelineProsByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_PIPELINE_PROSPEKTD_BYAFID, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_PIPELINE_PROSPEKTD_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getutFallProsByAfid
export const getutFallProsByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALL_PROSPEKTD_BYAFID});
    await axios.get('kontos/DashBoard/UFPROByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,FilterOption
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getutFallProsByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_UTFALL_PROSPEKTD_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getutFallProsByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UTFALL_PROSPEKTD_BYAFID, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UTFALL_PROSPEKTD_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
// ON_START_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID,ON_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID,ON_ERROR_UTFALL_PROBABILITY_PROSPEKT_BYAFID,
export const getutFallProsProbByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID});
    await axios.get('kontos/DashBoard/UFPROPByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,FilterOption
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getutFallProsProbByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_UTFALL_PROBABILITY_PROSPEKT_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getutFallProsProbByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UTFALL_PROBABILITY_PROSPEKT_BYAFID, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UTFALL_PROBABILITY_PROSPEKT_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
// ON_START_FETCH_AVTAL_VALUE_YEAR_BYAFID,ON_FETCH_AVTAL_VALUE_YEAR_BYAFID,ON_ERROR_AVTAL_VALUE_YEAR_BYAFID,
export const getAvtalVardeYearByAfid = (Afid,userid,FilterOption, Anpassad = 0,Taggs=[], callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_AVTAL_VALUE_YEAR_BYAFID});
    await axios.get('kontos/DashBoard/AVVYByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
userid:userid,FilterOption,Anpassad,Taggs
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getAvtalVardeYearByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_AVTAL_VALUE_YEAR_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getAvtalVardeYearByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_AVTAL_VALUE_YEAR_BYAFID, payload: ndate.error});
      }
      
     }).catch(function (error) {
       dispatch({type: ON_ERROR_AVTAL_VALUE_YEAR_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
// ON_START_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID,ON_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID,ON_ERROR_UTFALL_ANTAL_PROSPEKT_BYAFID,
export const getutFallProsAntalByAfid = (Afid,userid,FilterOption) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    dispatch({type: ON_START_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID});
     await axios.get('kontos/DashBoard/UFPROAByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,FilterOption
    })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getutFallProsAntalByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_UTFALL_ANTAL_PROSPEKT_BYAFID, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getutFallProsAntalByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UTFALL_ANTAL_PROSPEKT_BYAFID, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UTFALL_ANTAL_PROSPEKT_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
} 
//getUtfalldiagramSByAfid
export const getUtfalldiagramSByAfid = (Afid,userid,FilterOptions, intervaltype = 1,Datum=0, Anpassad = 0,Taggs=[], callBackFunc) =>{
 //const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALLS_PROSPEKTD_BYAFID});
    await axios.get('kontos/DashBoard/UFDPROByAfud',
    { params:encrypt(JSON.stringify({
      Afid:Afid,
      userid:userid,
      FilterOption:FilterOptions,
      intervaltype:intervaltype,
      Datum:Datum,
Anpassad,
Taggs
  })), 
    /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
     ).then((data) => {
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getUtfalldiagramSByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_UTFALLS_PROSPEKTD_BYAFID, payload: ndate.results});
        if(callBackFunc){callBackFunc(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getUtfalldiagramSByAfid: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UTFALLS_PROSPEKTD_BYAFID, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UTFALLS_PROSPEKTD_BYAFID, payload: error.message});
        console.log("Error****:", error.message); 
       if(error.message === "Network Error"){
          //reload and remove token 
         // //dispatch(userSignOut())
       } 
     });
  }
}
//getGnomMoteByUserid
export const getGnomMoteByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0,callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_GENOM_MOTE});
   await axios.get('kontos/DashBoard/getGENMOBU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAktiviterByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_GENOM_MOTE, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAktiviterByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_GENOM_MOTE, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_GENOM_MOTE, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
//getAVbokaMoteByUserid 
export const getAVbokaMoteByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVBOKA_MOTE});
     await axios.get('kontos/DashBoard/getAVBMOBU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAVbokaMoteByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AVBOKA_MOTE, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAVbokaMoteByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_AVBOKA_MOTE, payload: ndate.error});
        }
    
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_AVBOKA_MOTE, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 //getBefMoteByUserid
 export const getBefMoteByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_BEFKUND_MOTE});
     await axios.get('kontos/DashBoard/getBEFMOBU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getBefMoteByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_BEFKUND_MOTE, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getBefMoteByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_BEFKUND_MOTE, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_BEFKUND_MOTE, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 //getNYMoteByUserid
 export const getNYMoteByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0,callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_NYKUND_MOTE});
     await axios.get('kontos/DashBoard/getNYMOBU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getNYMoteByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_NYKUND_MOTE, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getNYMoteByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_NYKUND_MOTE, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_NYKUND_MOTE, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 
 //getUppNYMoteByUserid
 export const getUppNYMoteByUserid = (userid,Afid,FilterOption, intervaltype = 1,Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_NYUPPKUND_MOTE});
     await axios.get('kontos/DashBoard/getUppNYMOBU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUppNYMoteByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_NYUPPKUND_MOTE, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUppNYMoteByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_NYUPPKUND_MOTE, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_NYUPPKUND_MOTE, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 //getTopListKontorByAfid
export const getTopListKontorByAfid = (Afid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_TOPLIST_KONTOR_BYAFID});
     await axios.get('kontos/DashBoard/TpLSBkonByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,FilterOption:FilterOption
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getTopListKontorByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_TOPLIST_KONTOR_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getTopListKontorByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_TOPLIST_KONTOR_BYAFID, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_TOPLIST_KONTOR_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getTopListKontorAntalByAfid
 export const getTopListKontorAntalByAfid = (Afid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_LIST_KONTOR_BYAFID});
     await axios.get('kontos/DashBoard/TPLKONANByAf',
     { params:encrypt(JSON.stringify({
       Afid:Afid,FilterOption:FilterOption
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getTopListKontorAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_LIST_KONTOR_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getTopListKontorAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_LIST_KONTOR_BYAFID, payload: ndate.error});
        }
    
      }).catch(function (error) {
        dispatch({type: ON_ERROR_LIST_KONTOR_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getUtfalldiagramKontoVunnnByAfid
 export const getUtfalldiagramKontoVunnnByAfid = (Afid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALLS_KONTOR_BYAFID});
     await axios.get('kontos/DashBoard/UFDKONByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,FilterOption
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramKontoVunnnByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_UTFALLS_KONTOR_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramKontoVunnnByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UTFALLS_KONTOR_BYAFID, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UTFALLS_KONTOR_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getUtfalldiagramKontoSkapadProByAfid
 export const getUtfalldiagramKontoSkapadProByAfid = (Afid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async(dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALLSPRO_KONTOR_BYAFID});
      await axios.get('kontos/DashBoard/UFDKONPRByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,FilterOption
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramKontoSkapadProByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_UTFALLSPRO_KONTOR_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramKontoSkapadProByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UTFALLSPRO_KONTOR_BYAFID, payload: ndate.error});
        }
    
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UTFALLSPRO_KONTOR_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 
 //getUtfalldiagramKontoKlarAktByAfid
 export const getUtfalldiagramKontoKlarAktByAfid = (Afid) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALLSKAKT_KONTOR_BYAFID});
     await axios.get('kontos/DashBoard/UFDKONKAKTByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramKontoKlarAktByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_UTFALLSKAKT_KONTOR_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramKontoKlarAktByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UTFALLSKAKT_KONTOR_BYAFID, payload: ndate.error});
        }
    
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UTFALLSKAKT_KONTOR_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 
 //getUtfalldiagramKontoSkapadProByAfid
 export const getUtfalldiagramKontoorderByAfid = (Afid) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALLSORD_KONTOR_BYAFID});
     axios.get('kontos/DashBoard/UFDKONORDByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramKontoorderByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_UTFALLSORD_KONTOR_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramKontoorderByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UTFALLSORD_KONTOR_BYAFID, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UTFALLSORD_KONTOR_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getUtfalldiagramKontoNOffertByAfid
export const getUtfalldiagramKontoNOffertByAfid = (Afid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALLSNOFF_KONTOR_BYAFID});
     await axios.get('kontos/DashBoard/UFDKONOFFByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,FilterOption
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramKontoNOffertByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_UTFALLSNOFF_KONTOR_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramKontoNOffertByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UTFALLSNOFF_KONTOR_BYAFID, payload: ndate.error});
        }
    
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UTFALLSNOFF_KONTOR_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getUtfalldiagramKontotByAfid
export const getUtfalldiagramKontotByAfid = (Afid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALLSBMOTE_KONTOR_BYAFID});
     await axios.get('kontos/DashBoard/UFDKONFByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,FilterOption
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramKontotByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_UTFALLSBMOTE_KONTOR_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramKontotByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UTFALLSBMOTE_KONTOR_BYAFID, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UTFALLSBMOTE_KONTOR_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getKontoLastVunnenByAfid
export const getKontoLastVunnenByAfid = (Afid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async(dispatch) => {
     dispatch({type: ON_START_FETCH_LASTVUNNEN_KONTOR_BYAFID});
     await axios.get('kontos/DashBoard/UFDKONLVUByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,FilterOption
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getKontoLastVunnenByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_LASTVUNNEN_KONTOR_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getKontoLastVunnenByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_LASTVUNNEN_KONTOR_BYAFID, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_LASTVUNNEN_KONTOR_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getKontoLastBokadeByAfid
export const getKontoLastBokadeByAfid = (Afid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_BOKADE_KONTOR_BYAFID});
      await axios.get('kontos/DashBoard/UFDKONLBMByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,FilterOption
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getKontoLastBokadeByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_BOKADE_KONTOR_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getKontoLastBokadeByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_BOKADE_KONTOR_BYAFID, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_BOKADE_KONTOR_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getCountOffertByUserid
export const getCountOffertByUserid = (userid,Afid,FilterOption, intervaltype = 1, Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_COUNT_OFFERT_MONTH});
     await axios.get('kontos/DashBoard/getCNTOFVMBU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getCountOffertByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_COUNT_OFFERT_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getCountOffertByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_COUNT_OFFERT_MONTH, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_COUNT_OFFERT_MONTH, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getNyaArendeCountByUserid= (userid,Afid,FilterOption, intervaltype = 1, Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_COUNT_ARENDE_NY_MONTH});
     await axios.get('kontos/DashBoard/getCNABU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getNyaArendeCountByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_COUNT_ARENDE_NY_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getNyaArendeCountByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_NY_MONTH, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_NY_MONTH, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getAvslutadeArendeCountByUserid= (userid,Afid,FilterOption, intervaltype = 1, Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_COUNT_ARENDE_KLARA_MONTH});
     await axios.get('kontos/DashBoard/getCAABU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAvslutadeArendeCountByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_COUNT_ARENDE_KLARA_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAvslutadeArendeCountByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_KLARA_MONTH, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_KLARA_MONTH, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getOppnaArendeCountByUserid= (userid,Afid,FilterOption, intervaltype = 1, Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_COUNT_ARENDE_OPPNA_MONTH});
     await axios.get('kontos/DashBoard/getCAOBU',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption, intervaltype,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAvslutadeArendeCountByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_COUNT_ARENDE_OPPNA_MONTH, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAvslutadeArendeCountByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_OPPNA_MONTH, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_OPPNA_MONTH, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }

export const getProjectWorkload = (Afid,userid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_PROJECT_WORKLOAD});
     await axios.get('kontos/DashBoard/getPWL',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getProjectWorkload: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_PROJECT_WORKLOAD, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getProjectWorkload: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_PROJECT_WORKLOAD, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_PROJECT_WORKLOAD, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getProjectStatusListAntal = (Afid,userid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_PROJECT_STATUS_LIST_ANTAL});
     await axios.get('kontos/DashBoard/getPSLA',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getProjectStatusListAntal: ", endata);
          let ndate = JSON.parse(endata)
          console.log("getProjectStatusListAntal: ", ndate.results);
          dispatch({type: ON_FETCH_PROJECT_STATUS_LIST_ANTAL, payload: ndate.results.ProjektStatusAntalList});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getProjectStatusListAntal: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_PROJECT_STATUS_LIST_ANTAL, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_PROJECT_STATUS_LIST_ANTAL, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getProjectDeadlineListAntal = (Afid,userid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_PROJECT_DEADLINE_LIST_ANTAL});
     await axios.get('kontos/DashBoard/getPDLA',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getProjectDeadlineListAntal: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_PROJECT_DEADLINE_LIST_ANTAL, payload: ndate.results.ProjektDeadlineAntalList});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getProjectDeadlineListAntal: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_PROJECT_DEADLINE_LIST_ANTAL, payload: ndate.error});
        } 
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_PROJECT_DEADLINE_LIST_ANTAL, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getArendeNyaOppnaAntal = (Afid,userid,FilterOption, Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_COUNT_ARENDE_NYA_TOP_LIST});
     await axios.get('kontos/DashBoard/getANOA',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getArendeNyaOppnaAntal: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_COUNT_ARENDE_NYA_TOP_LIST, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getArendeNyaOppnaAntal: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_NYA_TOP_LIST, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_NYA_TOP_LIST, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 
export const getArendeNyaOppnaPagaendeAlder = (Afid,userid,FilterOption, Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER});
     await axios.get('kontos/DashBoard/getAOPA',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getArendeNyaOppnaPagaendeAlder: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getArendeNyaOppnaPagaendeAlder: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_NYA_PAGAENDE_ALDER, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getArendeNyaStangdaYear= (userid, Afid,FilterOption, Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR});
     await axios.get('kontos/DashBoard/getANSY',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getArendeNyaStangdaYear: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getArendeNyaStangdaYear: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_COUNT_ARENDE_NYA_STANGDA_YEAR, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 
export const getAvtalLoperutOmforYear= (userid, Afid,FilterOption, Anpassad = 0,Taggs=[], callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR});
     await axios.get('kontos/DashBoard/getALOMBYAF',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,Anpassad,Taggs})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAvtalLoperutOmforYear: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAvtalLoperutOmforYear: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_COUNT_AVTAL_LOPERUT_OMFOR_YEAR, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 
export const getLastArendenByAfid= (userid, Afid,FilterOption,intervaltype = 0, Anpassad = 0, callBackFunc) =>{

  console.log(userid, Afid,FilterOption, 'getLastArendenByAfid')
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_COUNT_LAST_ARENDE});
     await axios.get('kontos/DashBoard/getLABYAF',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption,Anpassad})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getLastArendenByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_COUNT_LAST_ARENDE, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getLastArendenByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_COUNT_LAST_ARENDE, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_COUNT_LAST_ARENDE, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getProjectKortKlaraTM = (userid,Afid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_PROJECT_KLARA_KORT_TM});
     await axios.get('kontos/DashBoard/getPCDTM',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getProjectKortKlaraTM: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_PROJECT_KLARA_KORT_TM, payload: ndate.ProjektKlaraKortTM});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getProjectKortKlaraTM: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_PROJECT_KLARA_KORT_TM, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_PROJECT_KLARA_KORT_TM, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getProjectKortKvarTM = (userid,Afid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_PROJECT_KORT_KVAR_TM});
     await axios.get('kontos/DashBoard/getPCLTM',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getProjectKortKvarTM: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_PROJECT_KORT_KVAR_TM, payload: ndate.ProjektKortKvarTM});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getProjectKortKvarTM: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_PROJECT_KORT_KVAR_TM, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_PROJECT_KORT_KVAR_TM, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }

export const getProjectCreatedVsCompleted = (Afid,userid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_PROJECT_CREATEDVSCOMPLETED});
     await axios.get('kontos/DashBoard/getPCVC',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getProjectCreatedVsCompleted: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_PROJECT_CREATEDVSCOMPLETED, payload: ndate.ProjectCreatedVsCompleted});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getProjectCreatedVsCompleted: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_PROJECT_CREATEDVSCOMPLETED, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_PROJECT_CREATEDVSCOMPLETED, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getProjectTasks= (Afid,userid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_PROJECT_TASKS});
     axios.get('kontos/DashBoard/getPT',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getProjectTasks: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_PROJECT_TASKS, payload: ndate.ProjectTasks});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getProjectTasks: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_PROJECT_TASKS, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_PROJECT_TASKS, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }

export const getProjectTimeSpent= (Afid,userid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async(dispatch) => {
     dispatch({type: ON_START_FETCH_PROJECT_TIMESPENT});
     await axios.get('kontos/DashBoard/getPTS',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getProjectTasks: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_PROJECT_TIMESPENT, payload: ndate.ProjectTimeSpent});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getProjectTasks: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_PROJECT_TIMESPENT, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_PROJECT_TIMESPENT, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
export const getProjectAheadBehind= (Afid,userid,FilterOption) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_PROJECT_AHEAD_BEHIND});
     await axios.get('kontos/DashBoard/getPAB',
     { params:encrypt(JSON.stringify({userid:userid,Afid:Afid,FilterOption:FilterOption})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getProjectAheadBehind: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_PROJECT_AHEAD_BEHIND, payload: ndate.ProjectAheadBehind});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getProjectAheadBehind: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_PROJECT_AHEAD_BEHIND, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_PROJECT_AHEAD_BEHIND, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 //getDashboardFilter
export const getDashboardSaljFilter = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_DASHBOARD_SALJ_FILTER});
     axios.get('kontos/DashBoard/Salj/Filter',
     { params:encrypt(JSON.stringify({
       userid:userid,
       Afid:Afid,
       Filterstate:Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAktiviterByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_DASHBOARD_SALJ_FILTER, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAktiviterByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_DASHBOARD_SALJ_FILTER, payload: ndate.error});
        }
    
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_DASHBOARD_SALJ_FILTER, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 
 //getDashboardProspektFilter
export const getDashboardProspektFilter = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_DASHBOARD_PROSPEKT_FILTER});
     axios.get('kontos/DashBoard/prospekt/Filter',
     { params:encrypt(JSON.stringify({
       userid:userid,
       Afid:Afid,
       Filterstate:Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAktiviterByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_DASHBOARD_PROSPEKT_FILTER, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAktiviterByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_DASHBOARD_PROSPEKT_FILTER, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_DASHBOARD_PROSPEKT_FILTER, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 
 //getDashboardKontorFilter
 export const getDashboardKontorFilter = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_DASHBOARD_KONTOR_FILTER});
     axios.get('kontos/DashBoard/Kontor/Filter',
     { params:encrypt(JSON.stringify({
       userid:userid,
       Afid:Afid,
       Filterstate:Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getDashboardKontorFilter: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_DASHBOARD_KONTOR_FILTER, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getDashboardKontorFilter: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_DASHBOARD_KONTOR_FILTER, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_DASHBOARD_KONTOR_FILTER, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 //getDashboardDialerFilter
export const getDashboardDialerFilter = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_DASHBOARD_DIALER_FILTER});
     axios.get('kontos/DashBoard/Dialer/Filter',
     { params:encrypt(JSON.stringify({
       userid:userid,
       Afid:Afid,
       Filterstate:Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getDashboardDialerFilter: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_DASHBOARD_DIALER_FILTER, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getDashboardDialerFilter: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_DASHBOARD_DIALER_FILTER, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_DASHBOARD_DIALER_FILTER, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 //getDashboardBokaFilter
export const getDashboardBokaFilter = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_DASHBOARD_BOKA_FILTER});
     axios.get('kontos/DashBoard/Boka/Filter',
     { params:encrypt(JSON.stringify({
       userid:userid,
       Afid:Afid,
       Filterstate:Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAktiviterByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_DASHBOARD_BOKA_FILTER, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAktiviterByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 //getDashboardBokaFilter
export const getDashboardOrderFilter = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_DASHBOARD_ORDER_FILTER});
     axios.get('kontos/DashBoard/Order/Filter',
     { params:encrypt(JSON.stringify({
       userid:userid,
       Afid:Afid,
       Filterstate:Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getDashboardOrderFilter: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_DASHBOARD_ORDER_FILTER, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getDashboardOrderFilter: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
 
export const getDashboardBarnFilter = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_DASHBOARD_BOKA_FILTER});
     axios.get('kontos/DashBoard/Barn/Filter',
     { params:encrypt(JSON.stringify({
       userid:userid,
       Afid:Afid,
       Filterstate:Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getDashboardOrderFilter: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_DASHBOARD_BARN_FILTER, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getDashboardOrderFilter: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER, payload: ndate.error});
        }
   
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_DASHBOARD_BOKA_FILTER, payload: error.message});
        console.log("Error****:", error.message);
        
        if(error.message === "Network Error"){
         //reload and remove token 
         //dispatch(userSignOut())
      }
      });
   }
 }
//getOrderTypeAntalByAfid 
export const getOrderTypeAntalByAfid = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async(dispatch) => {
     dispatch({type: ON_START_FETCH_ORDERTYPE_ANTAL_BYAFID});
     await axios.get('kontos/DashBoard/OAOTByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getOrderTypeAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_ORDERTYPE_ANTAL_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getOrderTypeAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_ORDERTYPE_ANTAL_BYAFID, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDERTYPE_ANTAL_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//  ON_START_FETCH_PROSPEKTTYPE_ANTAL_BYAFID,ON_FETCH_PROSPEKTTYPE_ANTAL_BYAFID,ON_ERROR_PROSPEKTTYPE_ANTAL_BYAFID,
export const getProspektTypeAntalByAfid = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_PROSPEKTTYPE_ANTAL_BYAFID});
     await axios.get('kontos/DashBoard/OAPTByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getProspektTypeAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_PROSPEKTTYPE_ANTAL_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getProspektTypeAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_PROSPEKTTYPE_ANTAL_BYAFID, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_PROSPEKTTYPE_ANTAL_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//  ON_START_FETCH_AVTAL_TYPE_ANTAL_BYAFID ,ON_FETCH_AVTAL_TYPE_ANTAL_BYAFID, ON_ERROR_AVTAL_TYPE_ANTAL_BYAFID,
export const getAvtalTypeAntalByAfid = (Afid,userid,Filterstate,intervaltype = 1, Anpassad = 0,Taggs=[], callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTAL_TYPE_ANTAL_BYAFID});
     await axios.get('kontos/DashBoard/OAATByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,Filterstate,
intervaltype,
Anpassad,Taggs
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAvtalTypeAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AVTAL_TYPE_ANTAL_BYAFID, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAvtalTypeAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_AVTAL_TYPE_ANTAL_BYAFID, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_AVTAL_TYPE_ANTAL_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
export const getAvtalGrowthByAfid = (Afid,userid,Filterstate,TypeOptionGrowth, Anpassad = 0, callBackFunc) =>{
  //const jwt =  JSON.parse(localStorage.token);
  // ON_START_FETCH_AVTAL_GROWTH_BYAFID, ON_FETCH_AVTAL_GROWTH_BYAFID, ON_ERROR_AVTAL_GROWTH_BYAFID,
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVTAL_GROWTH_BYAFID});
     await axios.get('kontos/DashBoard/AGBYAfuid',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,Filterstate,
       TypeOptionGrowth:TypeOptionGrowth,Anpassad
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAvtalGrowthByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AVTAL_GROWTH_BYAFID, payload: ndate.results});
          if(callBackFunc){callBackFunc(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAvtalGrowthByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_AVTAL_GROWTH_BYAFID, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_AVTAL_GROWTH_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getArtiklarAntalByAfid 
export const getArtiklarAntalByAfid = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_ARTIKLAR_ANTAL_BYAFID});
     await axios.get('kontos/DashBoard/OAARTByAfud',
     { params: encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getArtiklarAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_ARTIKLAR_ANTAL_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getArtiklarAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_ARTIKLAR_ANTAL_BYAFID, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_ARTIKLAR_ANTAL_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getAntalNyaOrderByAfid 
export const getAntalNyaOrderByAfid = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_NY_ORDER_ANTAL_BYAFID});
     await axios.get('kontos/DashBoard/OANORByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAntalNyaOrderByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_NY_ORDER_ANTAL_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAntalNyaOrderByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_NY_ORDER_ANTAL_BYAFID, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_NY_ORDER_ANTAL_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getTotaltOrderArtiklarByAfid
export const getTotaltOrderArtiklarByAfid = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID});
     axios.get('kontos/DashBoard/OANORARTByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAntalNyaOrderByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_NY_ORDER_ARTIKLAR_ANTAL_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAntalNyaOrderByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_NY_ORDER_ARTIKLAR_ANTAL_BYAFID, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_NY_ORDER_ARTIKLAR_ANTAL_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 
//getDashOrderStatusListByUserid 
export const getDashOrderStatusListByUserid = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_STATUS_ORDER_ANTAL_BYAFID});
      await axios.get('kontos/DashBoard/OANORSByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getDashOrderStatusListByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_STATUS_ORDER_ANTAL_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getDashOrderStatusListByUserid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_STATUS_ORDER_ANTAL_BYAFID, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_STATUS_ORDER_ANTAL_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getHasAboonemangeByAfid
 export const getHasAboonemangeByAfid = (Afid) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_STATUS_HAS_ABONN});
     axios.get('kontos/DashBoard/HasAbonn',
     { params:encrypt(JSON.stringify({
       Afid:Afid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getHasAboonemangeByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_STATUS_HAS_ABONN, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getHasAboonemangeByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_STATUS_HAS_ABONN, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_STATUS_HAS_ABONN, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getHasOrderVardeByAfid
 export const getHasOrderVardeByAfid = (Afid) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_FETCH_STATUS_HAS_ORERV});
     axios.get('kontos/DashBoard/HasOrderVarde',
     { params:encrypt(JSON.stringify({
       Afid:Afid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getHasOrderVardeByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_STATUS_HAS_ORERV, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getHasOrderVardeByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_STATUS_HAS_ORERV, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_STATUS_HAS_ORERV, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getOrderVardeListByAfid
export const getOrderVardeListByAfid = (Afid,userid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_ORDER_VARDE_YEAR});
     await axios.get('kontos/DashBoard/OANORVYRByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getOrderVardeListByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_ORDER_VARDE_YEAR, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getOrderVardeListByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_ORDER_VARDE_YEAR, payload: ndate.error});
        }
    
      }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDER_VARDE_YEAR, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }

//getTopListChildKontorByAfid
export const getTopListChildKontorByAfid = (Afid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_TOPLIST_CHILD_KONTO_BYAFID});
     await axios.get('kontos/DashBoard/TpLSBCBkonByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getTopListChildKontorByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_TOPLIST_CHILD_KONTO_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getTopListChildKontorByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_TOPLIST_CHILD_KONTO_BYAFID, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_TOPLIST_CHILD_KONTO_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getTopListKontoBarnAntalByAfid
 export const getTopListKontoBarnAntalByAfid = (Afid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_LIST_CHILD_KONTO_BYAFID});
     await axios.get('kontos/DashBoard/TPLCBKONANByAf',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getTopListKontoBarnAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_LIST_CHILD_KONTO_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getTopListKontoBarnAntalByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_LIST_CHILD_KONTO_BYAFID, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_LIST_CHILD_KONTO_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getUtfalldiagramBarnKontoVunnnByAfid
 export const getUtfalldiagramBarnKontoVunnnByAfid = (Afid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALLS_CHILD_KONTO_BYAFID});
     await axios.get('kontos/DashBoard/UFDCBKONByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramBarnKontoVunnnByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_UTFALLS_CHILD_KONTO_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramBarnKontoVunnnByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UTFALLS_CHILD_KONTO_BYAFID, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UTFALLS_CHILD_KONTO_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getUtfalldiagramBarnKontoSkapadProByAfid
export const getUtfalldiagramBarnKontoSkapadProByAfid = (Afid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async(dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID});
     await axios.get('kontos/DashBoard/UFDCBKONORDByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramBarnKontoSkapadProByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_UTFALLSORD_CHILD_KONTO_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramBarnKontoSkapadProByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UTFALLSORD_CHILD_KONTO_BYAFID, payload: ndate.error});
        }
     
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UTFALLSORD_CHILD_KONTO_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getUtfalldiagramBarnKontoSkapadORderByAfid
export const getUtfalldiagramBarnKontoSkapadORderByAfid = (Afid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_ORDRAR_CHILD_KONTO_BYAFID});
     await axios.get('kontos/DashBoard/UFDCBOrKONORDByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramBarnKontoSkapadProByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_ORDRAR_CHILD_KONTO_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramBarnKontoSkapadProByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_ORDRAR_CHILD_KONTO_BYAFID, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_ORDRAR_CHILD_KONTO_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getUtfalldiagramBarnKontorByAfid
export const getUtfalldiagramBarnKontorByAfid = (Afid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID});
      await axios.get('kontos/DashBoard/UFCBDKONFByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUtfalldiagramBarnKontorByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_UTFALLSBMOTE_CHILD_KONTO_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUtfalldiagramBarnKontorByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_UTFALLSBMOTE_CHILD_KONTO_BYAFID, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UTFALLSBMOTE_CHILD_KONTO_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getChildKontoLastVunnenByAfid
 export const getChildKontoLastVunnenByAfid = (Afid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID});
    await axios.get('kontos/DashBoard/UFDCBKONLVUByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getChildKontoLastVunnenByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_LASTVUNNEN_CHILD_KONTO_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getChildKontoLastVunnenByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_LASTVUNNEN_CHILD_KONTO_BYAFID, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_LASTVUNNEN_CHILD_KONTO_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
//getChildKontoLastBokadeByAfid
export const getChildKontoLastBokadeByAfid = (Afid,Filterstate) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async(dispatch) => {
     dispatch({type: ON_START_FETCH_BOKADE_CHILD_KONTO_BYAFID});
     await axios.get('kontos/DashBoard/UFDCBKONLBMByAfud',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Filterstate
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getChildKontoLastBokadeByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_BOKADE_CHILD_KONTO_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getChildKontoLastBokadeByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_BOKADE_CHILD_KONTO_BYAFID, payload: ndate.error});
        }
    
      }).catch(function (error) {
        dispatch({type: ON_ERROR_BOKADE_CHILD_KONTO_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getBokadeMotenBokadAvByAfid
export const getBokadeMotenBokadAvByAfid = (Afid,userid,FilterOption,intervaltype) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID});
     await axios.get('kontos/DashBoard/BokadeMotenBokadAv',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       FilterOption:FilterOption,
       intervaltype:intervaltype,
       userid:userid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getBokadeMotenBokadAvByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_BOKAMOTE_ANTAL_BOKAV_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getBokadeMotenBokadAvByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_BOKAMOTE_ANTAL_BOKAV_BYAFID, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_BOKAMOTE_ANTAL_BOKAV_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getBokadeMotenBokadTillByAfid
 export const getBokadeMotenBokadTillByAfid = (Afid,userid,FilterOption,intervaltype) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID});
     await axios.get('kontos/DashBoard/BokadeMotenBokadTill',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       FilterOption:FilterOption,
       intervaltype:intervaltype,
       userid:userid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getBokadeMotenBokadTillByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_BOKAMOTE_ANTAL_BOKTILL_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getBokadeMotenBokadTillByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_BOKAMOTE_ANTAL_BOKTILL_BYAFID, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_BOKAMOTE_ANTAL_BOKTILL_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getAvBokadeMotenBokadAvByAfid
 export const getAvBokadeMotenBokadAvByAfid = (Afid,userid,FilterOption,intervaltype) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID});
     await axios.get('kontos/DashBoard/AvBokadeMotenBokadAv',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       FilterOption:FilterOption,
       intervaltype:intervaltype,
       userid:userid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAvBokadeMotenBokadAvByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AVBOKAMOTE_ANTAL_BOKAV_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAvBokadeMotenBokadAvByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_AVBOKAMOTE_ANTAL_BOKAV_BYAFID, payload: ndate.error});
        }
    
      }).catch(function (error) {
        dispatch({type: ON_ERROR_AVBOKAMOTE_ANTAL_BOKAV_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 //getAvBokadeMotenBokadTillByAfid
 export const getAvBokadeMotenBokadTillByAfid = (Afid,userid,FilterOption,intervaltype) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID});
     await axios.get('kontos/DashBoard/AvBokadeMotenBokadTill',
     { params:encrypt(JSON.stringify({
       Afid:Afid,
       FilterOption:FilterOption,
       intervaltype:intervaltype,
       userid:userid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getAvBokadeMotenBokadTillByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getAvBokadeMotenBokadTillByAfid: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_AVBOKAMOTE_ANTAL_BOKTILL_BYAFID, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 export const getTotalSales = (Afid,userid,FilterOption,intervaltype=1, mainValue = 'default', Anpassad = 0, callback) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_TOTAL_SALES});
     await axios.get('kontos/DashBoard/getTotalSales',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Anpassad,intervaltype,mainValue,
       FilterOption:FilterOption,
       userid:userid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then( data  => {
        console.log("getTotalSales: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getTotalSales1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_TOTAL_SALES, payload: ndate.results});
          if(callback){callback(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getTotalSales2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_TOTAL_SALES, payload: ndate.error});
        }




      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_TOTAL_SALES, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 export const getMRR= (Afid,userid,FilterOption,mainValue = 'default',Anpassad=0,callback) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_MRR});
     await axios.get('kontos/DashBoard/getSBA',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Anpassad,mainValue,intervaltype:1,
       FilterOption:FilterOption,
       userid:userid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then( data  => {
        console.log("getMRR: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getMRR1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_FETCH_MRR, payload: ndate.results});
          if(callback){callback(ndate.results)}
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getMRR2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_FETCH_MRR, payload: ndate.error});
        }



       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_MRR, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 export const getARR = (Afid,userid,FilterOption,mainValue = 'default',Anpassad=0,callback) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_ARR});
     await axios.get('kontos/DashBoard/getSBA',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Anpassad,mainValue,intervaltype:2,
       FilterOption:FilterOption,
       userid:userid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then( data  => {
       console.log("getARR: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getARR1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_ARR, payload: ndate.results});
        if(callback){callback(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getARR2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_ARR, payload: ndate.error});
      }


      
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_ARR, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 export const getARPU = (Afid,userid,FilterOption,mainValue = 'default',Anpassad=0,callback) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return async (dispatch) => {
     dispatch({type: ON_START_FETCH_ARPU});
     await axios.get('kontos/DashBoard/getSBA',
     { params:encrypt(JSON.stringify({
       Afid:Afid,Anpassad,mainValue,intervaltype:1,
       FilterOption:FilterOption,
       userid:userid
     })), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then( data => {
       console.log("getARPU: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getARPU1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_FETCH_ARPU, payload: ndate.results});
        if(callback){callback(ndate.results)}
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getARPU2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_FETCH_ARPU, payload: ndate.error});
      }
      }).catch(function (error) {
        dispatch({type: ON_ERROR_FETCH_ARPU, payload: error.message});
         console.log("Error****:", error.message); 
        if(error.message === "Network Error"){
           //reload and remove token 
          // //dispatch(userSignOut())
        } 
      });
   }
 }
 
 

 export const setupdatedashboard = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD, payload: {set:1}});
   }
}
 export const setupdatedashboardBokaTV = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_BOKATV, payload: {set:1}});
   }
}
 export const setupdatedashboardOrderTV = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_ORDERTV, payload: {set:1}});
   }
}
 export const setupdatedashboardDialer = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_DIALER, payload: {set:1}});
   }
}
 export const setupdatedashboardAktivitet = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_AKTIVITET, payload: {set:1}});
   }
}
 export const setupdatedashboardProspekt = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_PROSPEKT, payload: {set:1}});
   }
}
 export const setupdatedashboardOffert = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_OFFERT, payload: {set:1}});
   }
}
 export const setupdatedashboardProjekt = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_PROJEKT, payload: {set:1}});
   }
}
 export const setupdatedashboardTidProjekt = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_TIDPROJEKT, payload: {set:1}});
   }
}
 export const setupdatedashboardArende = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_ARENDE, payload: {set:1}});
   }
}
 export const setupdatedashboardAvtal = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_AVTAL, payload: {set:1}});
   }
}
 export const setupdatedashboardLynes = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_LYNES, payload: {set:1}});
   }
}
 export const setupdatedashboardDevice = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_DEVICE, payload: {set:1}});
   }
}
 export const setupdatedashboardisMessage   = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_ISMESSAGE, payload: {set:1}});
   }
}
 export const setofUpdatedashboard = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD, payload: {set:0}});
   }
}
 export const setofUpdatedashboardBokaTV = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_BOKATV, payload: {set:0}});
   }
}
 export const setofUpdatedashboardOrderTV = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_ORDERTV, payload: {set:0}});
   }
}
 export const setofUpdatedashboardDialer = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_DIALER, payload: {set:0}});
   }
}
 export const setofUpdatedashboardAktivitet = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_AKTIVITET, payload: {set:0}});
   }
}
 export const setofUpdatedashboardProspekt = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_PROSPEKT, payload: {set:0}});
   }
}
 export const setofUpdatedashboardOffert = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_OFFERT, payload: {set:0}});
   }
}
 export const setofUpdatedashboardProjekt = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_PROJEKT, payload: {set:0}});
   }
}
 export const setofUpdatedashboardTidProjekt = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_TIDPROJEKT, payload: {set:0}});
   }
}
 export const setofUpdatedashboardArende = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_ARENDE, payload: {set:0}});
   }
}
 export const setofUpdatedashboardAvtal = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_AVTAL, payload: {set:0}});
   }
}
 export const setofUpdatedashboardLynes = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_LYNES, payload: {set:0}});
   }
}
 export const setofUpdatedashboardDevice = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_DEVICE, payload: {set:0}});
   }
}
 export const setofUpdatedashboardisMessage = () => {
  return (dispatch) => {
    dispatch({type: ON_GET_UPDATE_DASHBOARD_ISMESSAGE, payload: {set:0}});
   }
}
export const getCustomLobby = (Userid,Afid) =>{
  //const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_GET_LOBBY_CUSTOM});
     axios.get('kontos/Lobby/custom',
     { params:encrypt(JSON.stringify({Userid:Userid,Afid:Afid})), 
     /* headers: { 'Authorization': `Bearer ${jwt}`}*/ }      
      ).then((data) => {
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getCustomLobby: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_GET_LOBBY_CUSTOM, payload: ndate.results});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getCustomLobby: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_GET_LOBBY_CUSTOM, payload: ndate.error});
        }
      })
      .catch(function (error) {
        dispatch({type: ON_ERROR_GET_LOBBY_CUSTOM, payload: error.message});
        console.log("Error****:", error.message);
        if(error.message === "Network Error"){
           //reload and remove token 
           //dispatch(userSignOut())Not_User_Lobby
        }
        
      });
   }
 }
//
 